/**
 * Spanish Language Translations
 *
 * All text strings for the application in Spanish.
 */

export const es = {
  // Common
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Agregar',
    create: 'Crear',
    update: 'Actualizar',
    search: 'Buscar',
    filter: 'Filtrar',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    confirm: 'Confirmar',
    close: 'Cerrar',
    yes: 'Sí',
    no: 'No',
    all: 'Todos',
    none: 'Ninguno',
    select: 'Seleccionar',
    required: 'Requerido',
    optional: 'Opcional',
    actions: 'Acciones',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    new: 'Nuevo',
    previous: 'Anterior',
    next: 'Siguiente',
    page: 'Página',
    of: 'de',
    showing: 'Mostrando',
    noResults: 'No se encontraron resultados',
    records: 'registros',
    back: 'Volver',
    view: 'Ver',
    details: 'Detalles',
    invalidEmail: 'Email inválido',
    copied: 'Copiado al portapapeles',
    copy: 'Copiar',
    saving: 'Guardando...',
    days: 'días',
    viewAll: 'Ver todos',
    sortBy: 'Ordenar por',
    loadMore: 'Cargar más',
    saveFailed: 'No se pudo guardar',
    datePlaceholder: 'dd/mm/aaaa',
    clearDate: 'Limpiar fecha',
    selectEllipsis: 'Seleccionar…',
    toggleTheme: 'Cambiar tema',
    prevMonth: 'Mes anterior',
    nextMonth: 'Mes siguiente',
    goToday: 'Ir a hoy',
    other: 'Otro',
    errorOccurred: 'Ocurrió un error',
    noData: 'No hay datos',
    refresh: 'Actualizar',
    loadFailed: 'No se pudo cargar la información. Revise la conexión e intente de nuevo.',
    retry: 'Reintentar',
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    pos: 'Punto de Venta',
    articles: 'Artículos',
    clients: 'Clientes',
    bills: 'Facturación',
    proformas: 'Proformas',
    purchases: 'Compras',
    reports: 'Reportes',
    settings: 'Configuración',
    users: 'Usuarios',
    cashbox: 'Caja',
    logout: 'Cerrar Sesión',
    providers: 'Proveedores',
    families: 'Familias',
    groups: 'Líneas',
    locations: 'Ubicaciones',
    moneyReceipt: 'Recibo de Dinero',
    mainMenu: 'Menú principal',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    expandMenu: 'Expandir menú',
    collapseMenu: 'Colapsar menú',
    skipToContent: 'Saltar al contenido',
    approvals: 'Solicitudes',
  },

  // Solicitudes de aprobación (descuentos y cambios de precio)
  approvals: {
    title: 'Solicitudes de aprobación',
    subtitleAdmin: 'Descuentos, cambios de precio, salidas de inventario, anulaciones y devoluciones que piden los vendedores',
    subtitleSeller: 'Tus solicitudes de descuento, cambio de precio, salida de inventario, anulación y devolución. Las respuestas nuevas van resaltadas.',
    bellPending: '{count} solicitudes pendientes',
    newRequestsToast: 'Llegó una solicitud de aprobación',
    newAnswersToast: 'Te respondieron una solicitud',
    tabOpen: 'Abiertas',
    tabAll: 'Todas',
    empty: 'No hay solicitudes',
    kindDiscount: 'Descuento',
    kindPriceChange: 'Cambio de precio',
    kindStockOut: 'Salida de inventario',
    kindAnnulment: 'Anulación de factura',
    kindDevolution: 'Devolución de mercancía',
    currentStock: 'Existencias actuales: {stock}',
    statusPending: 'Pendiente',
    statusProcessing: 'Enviándose a Hacienda',
    statusApplied: 'Aplicada',
    statusRejected: 'Rechazada',
    statusCancelled: 'Cancelada',
    requestedBy: 'Pidió {name}',
    resolvedBy: 'Resolvió {name}',
    cancelledBy: 'Canceló {name}',
    cancelledBySystem: 'Cancelada por el sistema',
    bill: 'Factura {number}',
    lineDetail: '{quantity} × {price}',
    discountOf: '{percent} % de descuento',
    priceField: {
      purchase_cost: 'Costo',
      profit_1: 'Margen 1',
      profit_2: 'Margen 2',
      profit_3: 'Margen 3',
      sale_price_1_iva: 'Precio 1 (IVA incl.)',
      sale_price_2_iva: 'Precio 2 (IVA incl.)',
      sale_price_3_iva: 'Precio 3 (IVA incl.)',
      applied_sale_tax: 'Aplica IVA',
    },
    yes: 'Sí',
    no: 'No',
    note: 'Nota',
    noteOptional: 'Nota (opcional)',
    noteRequired: 'Escribí el motivo',
    approve: 'Aprobar',
    reject: 'Rechazar',
    cancel: 'Cancelar solicitud',
    rejectTitle: 'Rechazar solicitud',
    cancelTitle: 'Cancelar solicitud',
    confirmReject: 'Rechazar',
    confirmCancel: 'Cancelar solicitud',
    back: 'Volver',
    priceApplied: 'Precio actualizado',
    discountApplied: 'Descuento aplicado a la línea',
    approved: 'Solicitud aprobada',
    rejected: 'Solicitud rechazada',
    cancelled: 'Solicitud cancelada',
    // POS / línea
    discountNeedsApproval: 'El descuento lo aprueba un administrador',
    discountNeedsApprovalHelp: 'Se aplica a la línea cuando el administrador lo apruebe.',
    requestDiscount: 'Pedir aprobación',
    requestDiscountTitle: 'Pedir aprobación del descuento',
    requestSent: 'Solicitud enviada al administrador',
    waitingApproval: 'Esperando aprobación del {percent} %',
    rejectedNotice: 'El administrador rechazó el descuento del {percent} %',
    approvedNotice: 'El administrador aprobó el descuento del {percent} %: ya está en la línea',
    replacesRequest: 'Si enviás este descuento, reemplaza la solicitud del {percent} %.',
    discountMax: 'El descuento no puede pasar del 100 %',
    discountShown: '-{percent} % de descuento',
    openDiscounts: 'Hay descuentos esperando aprobación',
    openDiscountLine: '{description}: {percent} %',
    // Artículo
    priceNeedsApproval: 'Los cambios de precio los aprueba un administrador',
    priceRequestTitle: 'Pedir aprobación del cambio de precio',
    priceRequestHelp: 'Se guardan los demás datos del artículo. El precio cambia cuando el administrador apruebe.',
    priceRequestSent: 'Cambio de precio enviado al administrador',
    pendingPriceChange: 'Hay un cambio de precio esperando aprobación',
    send: 'Enviar solicitud',
    // Salidas de inventario
    stockOutNeedsApproval: 'La salida la aprueba un administrador. El motivo es obligatorio.',
    stockOutReasonRequired: 'Escribí el motivo de la salida',
    requestStockOut: 'Pedir aprobación de la salida',
    stockOutSent: 'Salida enviada al administrador. El stock baja cuando la apruebe.',
    pendingStockOut: 'Hay una salida de {quantity} unidades esperando aprobación.',
    stockOutReplaces: 'Si pedís esta, reemplaza a la anterior.',
    stockOutApplied: 'Salida registrada',
    // Anulación (nota de crédito motivo 01)
    annulmentNeedsApproval: 'La anulación la aprueba un administrador. Se envía a Hacienda cuando la apruebe.',
    requestAnnulment: 'Pedir aprobación de la anulación',
    annulmentSent: 'Anulación enviada al administrador',
    annulmentApplied: 'Factura anulada ante Hacienda',
    // Devolución (nota de crédito motivo 06)
    devolutionNeedsApproval: 'La devolución la aprueba un administrador. La nota se envía a Hacienda cuando la apruebe.',
    requestDevolution: 'Pedir aprobación de la devolución',
    devolutionSent: 'Devolución enviada al administrador',
    devolutionApplied: 'Nota de crédito enviada a Hacienda',
    openAnnulmentOnBill: 'Esta factura ya tiene una anulación pedida por {name}. Esperá la respuesta del administrador o cancelala en Solicitudes antes de hacer otra nota.',
    openNoteOnBillAdmin: '{name} pidió una nota de crédito para esta factura. Podés aprobarla en Solicitudes; si hacés la nota acá, la pedida se cierra sola.',
    openDevolutionOnBill: 'Esta factura ya tiene una devolución pedida por {name}. Esperá la respuesta del administrador o cancelala en Solicitudes antes de hacer otra nota.',
    // Permisos
    readOnly: 'Tu usuario es de solo consulta',
    adminOnlyAction: 'Solo un administrador puede hacer esto',
    sellerPriceLevel: 'Solo un administrador vende con precio 2 o 3',
  },

  // Catalogs
  catalogs: {
    // Providers
    providers: 'Proveedores',
    newProvider: 'Nuevo Proveedor',
    editProvider: 'Editar Proveedor',
    providerName: 'Nombre del Proveedor',
    contactName: 'Nombre de Contacto',
    economicActivity: 'Código de Actividad Económica',
    noProviders: 'No hay proveedores registrados',
    identificationInUse: 'Ya existe un proveedor con esa identificación',
    // Families
    families: 'Familias',
    newFamily: 'Nueva Familia',
    editFamily: 'Editar Familia',
    noFamilies: 'No hay familias registradas',
    // Groups/Lines
    groups: 'Líneas',
    newGroup: 'Nueva Línea',
    editGroup: 'Editar Línea',
    noGroups: 'No hay líneas registradas',
    // Locations
    locations: 'Ubicaciones',
    newLocation: 'Nueva Ubicación',
    editLocation: 'Editar Ubicación',
    noLocations: 'No hay ubicaciones registradas',
    // Common
    addFirst: 'Agrega el primero',
  },

  // Authentication / Login
  auth: {
    login: 'Iniciar Sesión',
    logout: 'Cerrar Sesión',
    username: 'Usuario',
    password: 'Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    forgotPassword: 'Olvidé mi contraseña',
    rememberMe: 'Recordarme',
    invalidCredentials: 'Credenciales inválidas',
    sessionExpired: 'Sesión expirada',
  },

  // Login page
  login: {
    title: 'Iniciar Sesión',
    subtitle: 'Ingresa tus credenciales para acceder',
    email: 'Email',
    password: 'Contraseña',
    emailPlaceholder: 'Ingresa tu email',
    passwordPlaceholder: 'Ingresa tu contraseña',
    login: 'Ingresar',
    loggingIn: 'Ingresando...',
    authError: 'Error de autenticación',
    invalidCredentials: 'Email o contraseña incorrectos',
    tooManyAttempts: 'Demasiados intentos fallidos. Esperá 15 minutos y volvé a intentar.',
    // Login page features
    completeSystem: 'Sistema completo de facturación',
    secureReliable: 'Seguro y Confiable',
    secureReliableDesc: 'Datos protegidos con los más altos estándares de seguridad',
    fastEfficient: 'Rápido y Eficiente',
    fastEfficientDesc: 'Punto de venta optimizado para agilizar tus operaciones',
    completeReports: 'Reportes Completos',
    completeReportsDesc: 'Análisis detallado de ventas, inventario y cuentas por cobrar',
  },

  // Articles
  articles: {
    cabysCurrent: 'CABYS actual',
    cabysValid: 'Código CABYS válido',
    cabysMissingDigits: 'Faltan {count} dígitos',
    cabysEnter13: 'Ingrese el código CABYS de 13 dígitos',
    cabysSearchHacienda: 'Buscar código CABYS en Hacienda',
    cabysMust13: 'El código CABYS debe tener 13 dígitos',
    title: 'Artículos',
    newArticle: 'Nuevo Artículo',
    editArticle: 'Editar Artículo',
    basicInfo: 'Información Básica',
    categories: 'Categorías',
    inventory: 'Inventario',
    createArticle: 'Crear Artículo',
    deleteArticle: 'Eliminar Artículo',
    searchPlaceholder: 'Buscar código o descripción...',
    noArticles: 'Sin artículos',
    addFirst: 'Agrega tu primer artículo',
    stock: 'Stock',
    lowStock: 'Stock bajo',
    price: 'Precio',
    code: 'Código',
    alternativeCode: 'Código Proveedor',
    autoGeneratedCode: 'Se genera automáticamente',
    codeEditableHint: 'Sugerido automáticamente, puede modificarlo',
    alternativeCodeHint: 'Del proveedor o el código de barras de fábrica; se puede escanear',
    alternativeCodeShared: 'También lo usa {code} · {description}',
    sharedCodeTitle: 'El código alterno {code} ya lo usan otros artículos',
    sharedCodeQuestion: '¿Es otra variante del mismo producto (por ejemplo, otro color)? Si es el mismo artículo creado otra vez, cancele y use el que ya existe.',
    sharedCodeConfirm: 'Sí, es una variante',
    sharedCodeCancel: 'Cancelar',
    description: 'Descripción',
    cabysCode: 'Código CABYS',
    cabysCodeHelp: 'Para facturación electrónica',
    family: 'Familia',
    group: 'Grupo',
    provider: 'Proveedor',
    location: 'Ubicación',
    allLocations: 'Todas las Ubicaciones',
    allFamilies: 'Todas las Familias',
    allGroups: 'Todos los Grupos',
    stockStatus: 'Estado Stock',
    allStock: 'Todo el Stock',
    lowStockOnly: 'Solo Stock Bajo',
    missingCabys: 'Sin CABYS',
    missingCabysOnly: 'Solo sin código CABYS',
    cabysWarning: 'Sin CABYS',
    cabysRequired2025: 'Requiere CABYS 2025',
    updateCabys: 'Actualizar CABYS',
    cabysUpdatedSuccess: 'Código CABYS actualizado',
    // Pricing
    pricing: 'Precios',
    purchaseCost: 'Costo',
    profitPrice1: '% Precio 1',
    profitPrice2: '% Precio 2',
    profitPrice3: '% Precio 3',
    applyIva: 'Aplicar 13% IVA',
    price1: 'Precio 1',
    price2: 'Precio 2',
    price3: 'Precio 3',
    margin: 'margen',
    // Stock
    currentStock: 'Stock Actual',
    minimumStock: 'Stock Mínimo',
    maximumStock: 'Stock Máximo',
    stockAdjustment: 'Ajuste de Inventario',
    initialQuantity: 'Cantidad inicial',
    alertWhenLow: 'Alerta cuando baje',
    alertWhenHigh: 'Límite máximo de inventario',
    adjustStock: 'Ajustar Stock',
    adjustmentType: 'Tipo de Ajuste',
    increase: 'Entrada',
    decrease: 'Salida',
    quantity: 'Cantidad',
    reason: 'Motivo',
    reasonPlaceholder: 'Ej: Conteo físico, devolución, daño...',
    applyAdjustment: 'Aplicar Ajuste',
    stockAdjustedSuccess: 'Stock ajustado exitosamente',
    adjustmentRequired: 'Ingrese una cantidad válida',
    units: 'unidades',
    // Messages
    confirmDelete: '¿Está seguro que desea eliminar',
    cannotUndo: 'Esta acción no se puede deshacer.',
    addedSuccess: 'Artículo agregado exitosamente',
    updatedSuccess: 'Artículo actualizado exitosamente',
    deletedSuccess: 'Artículo eliminado exitosamente',
    restoreArticle: 'Restaurar Artículo',
    confirmRestore: '¿Desea restaurar este artículo?',
    restoredSuccess: 'Artículo restaurado exitosamente',
    articleDeleted: 'Este artículo fue eliminado',
    showDeleted: 'Eliminados',
    confirmDeleteSoft: 'El artículo será desactivado. Podrá restaurarlo después desde la lista de eliminados.',
    confirmDeletePermanent: 'Este artículo no tiene facturas asociadas. Puede eliminarlo permanentemente (no se podrá recuperar) o desactivarlo.',
    confirmDeleteHasInvoices: 'Este artículo tiene facturas asociadas. Solo se puede desactivar (no eliminar permanentemente).',
    deactivate: 'Desactivar',
    deletePermanently: 'Eliminar permanentemente',
    // Dialog descriptions
    editDescription: 'Actualice la información del artículo.',
    newDescription: 'Agregue un nuevo artículo al inventario.',
    cabysPlaceholder: '13 dígitos',
    // Detail page
    additionalInfo: 'Información Adicional',
    backToArticles: 'Volver a Artículos',
    doesNotExist: 'El artículo no existe',
    errorLoading: 'Error al cargar el artículo',
    included: 'Incluido',
    iva: 'IVA',
    notApplicable: 'N/A',
    notFound: 'Artículo no encontrado',
    prices: 'Precios',
  },

  // Clients
  clients: {
    title: 'Clientes',
    newClient: 'Nuevo Cliente',
    editClient: 'Editar Cliente',
    deleteClient: 'Eliminar Cliente',
    searchPlaceholder: 'Buscar nombre o cédula...',
    noClients: 'Sin clientes',
    addFirst: 'Agrega tu primer cliente',
    name: 'Nombre',
    identificationType: 'Tipo de Identificación',
    identification: 'Número de Identificación',
    email: 'Correo Electrónico',
    emailHelp: 'Para facturas electrónicas',
    phone: 'Teléfono',
    address: 'Dirección',
    // Price levels
    priceLevel: 'Nivel de Precio',
    allPriceLevels: 'Todos los Precios',
    price1: 'Precio 1',
    price2: 'Precio 2',
    price3: 'Precio 3',
    priceLevelHelp: 'Determina los precios de venta',
    // Credit
    pricingAndCredit: 'Precios y Crédito',
    creditLimit: 'Límite de Crédito',
    creditDays: 'Días de Crédito',
    currentCredit: 'Crédito Actual',
    availableCredit: 'Crédito Disponible',
    noCredit: 'Sin crédito',
    creditTerm: 'Plazo de pago',
    withPendingCredit: 'Con Crédito Pendiente',
    // Identification types
    cedulaFisica: 'Cédula Física',
    cedulaJuridica: 'Cédula Jurídica',
    dimex: 'DIMEX',
    nite: 'NITE',
    foreigner: 'Extranjero',
    // Messages
    confirmDelete: '¿Está seguro que desea eliminar a',
    hasPendingCredit: 'Este cliente tiene crédito pendiente de',
    inactiveCannotPurchase: 'Clientes inactivos no pueden comprar',
    // Form sections
    createClient: 'Crear Cliente',
    basicInfo: 'Información Básica',
    contact: 'Contacto',
    credit: 'Crédito',
    celphone: 'Celular',
    paymentDays: 'Días de Pago',
    creditBlocked: 'Bloquear crédito',
    creditBlockedHint: 'El cliente no podrá comprar a crédito: en el punto de venta la factura pasa a contado.',
    creditBlockedBadge: 'Crédito bloqueado',
    // Hacienda v4.4 Commercial Activity
    commercialActivity: 'Actividad Comercial (Hacienda v4.4)',
    activityCode: 'Código de Actividad Comercial',
    // Fiscal Exoneration
    fiscalExoneration: 'Exoneración Fiscal',
    exoneratedClient: 'Cliente Exonerado',
    exoneratedClientHelp: 'Marque si el cliente tiene exoneración de impuestos',
    exonerationType: 'Tipo de Exoneración',
    selectExonerationType: 'Seleccione tipo',
    documentNumber: 'Número de Documento',
    exonerationNumberPlaceholder: 'Número de exoneración',
    exonerationInstitution: 'Institución que Exonera',
    exonerationInstitutionPlaceholder: 'Seleccionar institución',
    exonerationInstitutionOther: 'Detalle institución (Otros)',
    documentDate: 'Fecha del Documento',
    exonerationPercentage: 'Porcentaje de Exoneración (%)',
    fullExoneration: 'Exoneración total',
    // Table headers (short versions)
    activityCodeShort: 'Act. Comercial',
    exonerated: 'Exonerado',
    viewCredit: 'Ver crédito',
    // Detail page
    clientNotFound: 'Cliente no encontrado',
    errorLoadingClient: 'Error al cargar el cliente',
    clientDoesNotExist: 'El cliente no existe',
    backToClients: 'Volver a clientes',
    noContactInfo: 'Sin información de contacto',
    currentBalance: 'Saldo Actual',
    deposit: 'Depósito',
    type: 'Tipo',
    number: 'Número',
    percentage: 'Porcentaje',
    days: 'días',
    // Soft delete
    confirmDeleteSoft: 'El cliente será desactivado. Podrá restaurarlo después desde la lista de eliminados.',
    confirmDeletePermanent: 'Este cliente no tiene facturas asociadas. Puede eliminarlo permanentemente (no se podrá recuperar) o desactivarlo.',
    confirmDeleteHasInvoices: 'Este cliente tiene facturas asociadas. Solo se puede desactivar (no eliminar permanentemente).',
    deactivate: 'Desactivar',
    deletePermanently: 'Eliminar permanentemente',
    restoreClient: 'Restaurar',
    clientDeleted: 'Este cliente fue eliminado',
    showDeleted: 'Eliminados',
  },

  // Users
  users: {
    noAvatars: 'No hay avatares en esta categoría',
    title: 'Usuarios',
    newUser: 'Nuevo Usuario',
    editUser: 'Editar Usuario',
    deleteUser: 'Eliminar Usuario',
    addFirst: 'Agrega tu primer usuario',
    username: 'Usuario',
    usernameHelp: 'Usado para iniciar sesión. No se puede cambiar.',
    fullName: 'Nombre Completo',
    email: 'Correo Electrónico',
    emailIsLogin: 'Con este correo inicia sesión. Tiene que ser único: no puede estar usado en otra empresa.',
    role: 'Rol',
    lastLogin: 'Último Acceso',
    never: 'Nunca',
    you: '(tú)',
    user: 'Usuario',
    // Roles
    admin: 'Administrador',
    manager: 'Gerente',
    seller: 'Vendedor',
    cashier: 'Cajero',
    accountant: 'Contador',
    roleAdminDesc: 'Acceso total al sistema incluyendo gestión de usuarios',
    roleManagerDesc: 'Acceso a reportes, inventario y operaciones de caja',
    roleSellerDesc: 'Solo operaciones de punto de venta',
    // Password
    password: 'Contraseña',
    changePassword: 'Cambiar Contraseña',
    keepCurrentPassword: 'Dejar en blanco para mantener actual',
    confirmPassword: 'Confirmar Contraseña',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    // Messages
    confirmDelete: '¿Está seguro que desea eliminar al usuario',
    cannotDeleteSelf: 'No puedes eliminarte a ti mismo',
    inactiveCannotLogin: 'Usuarios inactivos no pueden iniciar sesión',
    // Form sections
    accountInfo: 'Información de Cuenta',
    personalInfo: 'Información Personal',
    roleAndStatus: 'Rol y Estado',
    createUser: 'Crear Usuario',
    activeDescription: 'Los usuarios inactivos no pueden iniciar sesión',
    // Detail page
    userNotFound: 'Usuario no encontrado',
    errorLoadingUser: 'Error al cargar el usuario',
    userDoesNotExist: 'Este usuario no existe',
    backToUsers: 'Volver a Usuarios',
    contactInfo: 'Información de Contacto',
    noEmail: 'Sin correo electrónico',
    activity: 'Actividad',
    createdAt: 'Fecha de creación',
    neverLoggedIn: 'Nunca ha iniciado sesión',
    // Role descriptions
    roleDescription: {
      admin: 'Acceso completo al sistema',
      manager: 'Gestión de inventario y reportes',
      seller: 'Solo punto de venta',
    },
    // Avatar
    avatar: 'Avatar',
    selectAvatar: 'Seleccionar Avatar',
    selectAvatarDescription: 'Elige un avatar para tu perfil',
    changeAvatar: 'Cambiar Avatar',
    avatarUpdated: 'Avatar actualizado correctamente',
  },

  // Billing / POS
  billing: {
    title: 'Punto de Venta',
    newSale: 'Nueva Venta',
    processPayment: 'Procesar Pago',
    // Payment methods
    paymentMethod: 'Método de Pago',
    cash: 'Efectivo',
    card: 'Tarjeta',
    transfer: 'Transferencia',
    credit: 'Crédito',
    // Amounts
    totalToPay: 'Total a Pagar',
    amountReceived: 'Monto Recibido',
    change: 'Vuelto',
    quickAdd: 'Agregar Rápido',
    exact: 'Exacto',
    clear: 'Limpiar',
    // Credit payment
    insufficientCredit: 'Crédito insuficiente. Necesita',
    more: 'más',
    termDays: 'Plazo (días)',
    confirmCreditSale: 'Confirmar Venta a Crédito',
    // Card/Transfer
    processCardTerminal: 'Procesar pago en terminal de tarjetas',
    confirmTransferReceived: 'Confirmar que la transferencia fue recibida',
    // Bill info
    billNumber: 'Número de Factura',
    billType: 'Tipo',
    ticket: 'Tiquete',
    invoice: 'Factura',
    creditNote: 'Nota de Crédito',
    proforma: 'Proforma',
    // Status
    pending: 'Pendiente',
    paid: 'Pagada',
    cancelled: 'Anulada',
    // Line items
    addItem: 'Agregar Artículo',
    quantity: 'Cantidad',
    unitPrice: 'Precio Unitario',
    discount: 'Descuento',
    lineTotal: 'Total Línea',
    subtotal: 'Subtotal',
    tax: 'IVA',
    total: 'Total',
    // Actions
    finalizeSale: 'Finalizar Venta',
    cancelSale: 'Cancelar Venta',
    printReceipt: 'Imprimir Recibo',
    sendByEmail: 'Enviar por Correo',
  },

  // Cashbox
  cashbox: {
    title: 'Caja',
    subtitle: 'Gestión de caja registradora',
    open: 'Abrir Caja',
    close: 'Cerrar Caja',
    opened: 'Caja abierta',
    closed: 'Caja cerrada',
    openedSuccess: 'La caja se ha abierto correctamente',
    closedSuccess: 'La caja se ha cerrado correctamente',
    openNote: 'Apertura de caja',
    closeNote: 'Cierre de caja',
    openError: 'Error al abrir la caja',
    closeError: 'Error al cerrar la caja',
    status: 'Estado',
    statusOpen: 'Abierta',
    statusClosed: 'Cerrada',
    currentBalance: 'Saldo Actual',
    openingBalance: 'Saldo Inicial',
    closingBalance: 'Saldo de Cierre',
    expectedBalance: 'Saldo Esperado',
    expected: 'Esperado',
    difference: 'Diferencia',
    realVsExpected: 'Real vs Esperado',
    sales: 'Ventas',
    todayTotal: 'Total de hoy',
    daySummary: 'Resumen de la Caja',
    initialAmount: 'Monto Inicial',
    finalAmount: 'Monto Final',
    enterInitialAmount: 'Ingrese el monto inicial de la caja',
    totalIncome: 'Total Ingresos',
    totalExpense: 'Total Egresos',
    noCashbox: 'No tienes una caja asignada',
    createCashbox: 'Crear Caja',
    cashboxCreated: 'Caja creada y asignada exitosamente',
    movements: 'Movimientos',
    deposit: 'Depósito',
    withdrawal: 'Retiro',
    reason: 'Motivo',
    cashSales: 'Ventas en Efectivo',
    cardSales: 'Ventas con Tarjeta',
    transferSales: 'Ventas por Transferencia',
    creditSales: 'Ventas a Crédito',
    cashSalesTotal: 'Ventas Contado',
    depositsReceived: 'Abonos Recibidos',
    expectedCashInRegister: 'Efectivo Esperado en Caja',
    cashSalesInCash: 'Ventas en Efectivo',
    depositsInCash: 'Abonos en Efectivo',
    devolutions: 'Devoluciones',
    cashDevolutions: 'Devoluciones en efectivo',
    expenses: 'Egresos',
    expectedCash: 'Efectivo Esperado',
    opening: 'Apertura',
    sinceOpening: 'Desde la apertura',
    cashOnly: 'Solo efectivo',
    allPaymentMethods: 'Todos los métodos de pago',
    openSince: 'Desde el {date} · monto inicial {amount}',
    noOpenCashbox: 'Sin caja abierta',
    devolutionsSplit: 'Efectivo {cash} · otros medios {others}',
    ingresos: 'Ingresos',
    creditDepositsTitle: 'Abonos a Crédito',
    creditSalesEmitted: 'Crédito Emitido',
    creditSalesEmittedHint: 'No suma a caja; se registra como abono cuando entra el dinero',
    bills: 'Facturas de esta caja',
    // Open/Close pages
    openCashbox: 'Abrir Caja',
    closeCashbox: 'Cerrar Caja',
    openedAt: 'Abierta desde',
    countCash: 'Contar Efectivo',
    quickAdd: 'Agregar rápido',
    startEmpty: 'Iniciar en cero',
    useExpected: 'Usar esperado',
    notes: 'Notas',
    openNotesPlaceholder: 'Observaciones al abrir (opcional)',
    closeNotesPlaceholder: 'Observaciones al cerrar (opcional)',
    explainDifference: 'Explique la diferencia encontrada...',
    recommendExplainDifference: 'Se recomienda explicar la diferencia',
    surplus: 'Sobrante',
    surplusDescription: 'El monto contado es mayor al esperado',
    shortage: 'Faltante',
    shortageDescription: 'El monto contado es menor al esperado',
    // History page
    history: 'Historial',
    sessions: 'sesiones',
    noHistory: 'No hay historial de cajas',
    noHistoryDesc: 'Las cajas cerradas aparecerán aquí',
    total: 'Total',
    // Tipos y estados de documentos dentro de una caja
    billTypeTicket: 'Tiquete',
    billTypeInvoice: 'Factura',
    billTypeProforma: 'Proforma',
    billTypeCreditNote: 'N. Crédito',
    billStatusPending: 'Pendiente',
    billStatusPaid: 'Pagada',
    billStatusFinalized: 'Finalizada',
    billStatusCancelled: 'Anulada',
    movementSale: 'Venta',
    movementIncome: 'Ingreso',
    movementExpense: 'Egreso',
    movementWithdrawal: 'Retiro',
    movementDeposit: 'Depósito',
    movementDevolution: 'Devolución',
    // Detalle de caja
    cashboxNumber: 'Caja #{id}',
    closing: 'Cierre',
    inProgress: 'En curso',
    userLabel: 'Usuario:',
    dateLabel: 'Fecha:',
    amountLabel: 'Monto:',
    finalAmountLabel: 'Monto final:',
    countedAtClose: 'Monto contado al cierre',
    noDifference: 'Sin diferencia',
    surplusInBox: 'Sobra en caja',
    shortageInBox: 'Falta en caja',
    reasonLabel: 'Motivo:',
    creditSection: 'Crédito',
    cashSection: 'Contado',
    subtotal: 'Subtotal',
    discount: 'Descuento',
    taxIva: 'Impuesto (IVA)',
    totalSalesSection: 'Total ventas',
    moneyReceiptSection: 'Recibo de dinero',
    depositsSection: 'Abonos',
    totalIncomeSection: 'Total ingresos',
    cashSalesSection: 'Ventas contado',
    devolutionsSection: 'Devoluciones',
    noMovements: 'No hay movimientos registrados',
    noBills: 'No hay facturas en esta caja',
    generalClient: 'Cliente general',
    // Historial
    openingUser: 'Usuario apertura',
    closingUser: 'Usuario cierre',
    openingDate: 'Fecha apertura',
    closingDate: 'Fecha cierre',
    openingAmount: 'Monto apertura',
    closingAmount: 'Monto cierre',
    closedColumn: 'Cerrada',
  },

  // Reports
  reports: {
    title: 'Reportes',
    copyForWhatsapp: 'Copiar para WhatsApp',
    totalReceivable: 'Total por cobrar',
    totalWithPending: 'Total con pendientes',
    statusCredit: 'Crédito',
    statusPending: 'Pendiente',
    pendingNotInDebt: 'Las pendientes (sin finalizar) no suman a la deuda real.',
    billCreatedDate: 'Fecha Creación',
    billInvoiceDate: 'Fecha Factura',
    billModifiedDate: 'Fecha Modificación',
    aboutTheseDates: 'Sobre estas fechas',
    billCreatedDateHelp: 'Fecha Creación: cuando se abrió la factura y salió la mercadería. Desde esta fecha se cuentan los días y la antigüedad de la deuda.',
    billInvoiceDateHelp: 'Fecha Factura: cuando se cobró y se emitió el comprobante ante Hacienda. Es la que lleva el documento del cliente.',
    billDatesDifferNote: 'Una factura dejada en "continuar después" puede tener las dos fechas a varios días de distancia.',
    salesReport: 'Reporte de Ventas',
    inventoryReport: 'Reporte de Inventario',
    creditReport: 'Reporte de Créditos',
    dateRange: 'Rango de Fechas',
    from: 'Desde',
    to: 'Hasta',
    today: 'Hoy',
    thisWeek: 'Esta Semana',
    thisMonth: 'Este Mes',
    export: 'Exportar',
    print: 'Imprimir',
    topSellingArticles: 'Artículos Más Vendidos',
    accountsReceivable: 'Cuentas por Cobrar',
    accountsPayable: 'Cuentas por Pagar',
    accountsPayableSubtitle: 'Deudas pendientes a proveedores',
    misc: {
      allProviders: 'Todos los proveedores',
      searchArticle: 'Buscar artículo…',
      needAttention: 'artículos requieren atención',
      zeroStockList: 'Artículos Sin Stock o Bajo Mínimo',
      sortCode: 'Código',
      sortNameAsc: 'Nombre (A-Z)',
      sortNameDesc: 'Nombre (Z-A)',
      profitSummary: 'Resumen de Ganancia Potencial',
      totalCost: 'Costo Total',
      saleValue: 'Valor de Venta',
      potentialProfit: 'Ganancia Potencial',
      checkZeroStock: 'Revise el reporte de stock en cero para más detalles',
      viewDetails: 'Ver detalles',
      salesRanking: 'Ranking de Ventas',
    },
    ar: {
      statementOf: 'Estado de cuenta — {name}',
      creditReceivable: 'Por cobrar (crédito)',
      pendingNotFinalized: 'Pendientes (sin finalizar)',
      billNumber: '# Factura',
      billCode: 'Código de Factura',
      clientName: 'Nombre de Cliente',
      balance: 'Saldo',
      aging: 'Antigüedad',
      totalAmount: 'Monto Total',
      totalDebits: 'Total Débitos',
      currentBalance: 'Saldo Actual',
      byAging: 'Por Antigüedad',
      byClient: 'Por Cliente',
      selectClient: 'Seleccionar cliente…',
      searchClient: 'Buscar cliente…',
      noClients: 'No se encontraron clientes',
      selectClientHint: 'Seleccione un cliente para ver sus cuentas por cobrar.',
      phone: 'Teléfono',
      mobile: 'Celular',
      address: 'Dirección',
    },
    selectReport: 'Seleccione un reporte para ver los detalles',
    salesSummaryDesc: 'Resumen de ventas del mes con totales e impuestos',
    topSellingArticlesDesc: 'Los artículos más vendidos con cantidades y montos',
    articleCostsDesc: 'Costos de compra, precios de venta y márgenes de ganancia',
    articlePricesDesc: 'Lista de precios detalle, mayorista y distribuidor',
    detailedSalesDesc: 'Detalle de cada línea vendida con cliente y fecha',
    accountsReceivableDesc: 'Cuentas por cobrar con antigüedad de deuda',
    zeroStockDesc: 'Artículos sin stock o por debajo del mínimo',
    inventoryValueDesc: 'Valor total del inventario a costo y precio de venta',
    totalPurchases: 'Total Compras',
    totalDeposited: 'Total Abonado',
    pendingBalance: 'Saldo Pendiente',
    pendingPurchases: 'Compras Pendientes de Pago',
    noPendingPurchases: 'No hay compras pendientes de pago',
    purchaseTotalLine: 'Total: {total} • Abonado: {deposited}',

    // Rango de fechas de los reportes
    dateFrom: 'Desde',
    dateTo: 'Hasta',

    // Historial de abonos
    depositsHistory: 'Historial de Abonos',
    depositDate: 'Fecha',
    depositClient: 'Cliente',
    depositsHistoryDesc: 'Todos los abonos recibidos de todos los clientes',
    depositOrigin: 'Origen',
    depositOriginAccount: 'A cuenta',
    depositOriginBill: 'A factura',
    depositAppliedTo: 'Aplicado a',
    depositMethod: 'Método',
    depositReceivedBy: 'Recibido por',
    depositsTotalReceived: 'Total recibido',
    depositsCount: 'Abonos',
    depositsAllMethods: 'Todos los métodos',
    depositsSearchClient: 'Buscar por cliente o nota',
    depositsNoDate: 'sin fecha',
    depositsUndatedNotice: 'Hay {count} abonos por {amount} sin fecha registrada, de un error ya corregido. No caben en ningún rango de fechas.',
    depositsUndatedInclude: 'Incluirlos en la lista',
    depositsUndatedIncluded: 'Incluidos al final de la lista',
    purchasesSummary: 'Resumen de Compras',
    salesSummary: 'Resumen de Ventas',
    inventoryValue: 'Valor del Inventario',
    taxCollected: 'IVA Cobrado',
    averageSale: 'Promedio de Venta',
    totalSales: 'Total Ventas',
    transactionsTitle: 'Transacciones',
    periodDetails: 'Detalles del Período',
    subtotalNoTax: 'Subtotal (sin IVA)',
    taxLabel: 'IVA',
    averagePerSale: 'Promedio por Venta',
    perTransaction: 'Por transacción',
    transactions: 'transacciones',
    cost: 'Costo',
    noDataAvailable: 'No hay datos disponibles',
    noPendingAccounts: 'No hay cuentas pendientes',
    units: 'uds',
    invoices: 'facturas',
    since: 'Desde',
    // Nuevos reportes
    articleCosts: 'Costos de Artículos',
    articlePrices: 'Precios de Artículos',
    articleCostsSubtitle: 'Costos y márgenes de ganancia',
    articlePricesSubtitle: 'Precios por nivel de cliente',
    costAnalysis: 'Análisis de costos',
    priceList: 'Lista de precios',
    articlesCount: '{count} artículos',
    sortCode: 'Código',
    sortNameAsc: 'Nombre (A-Z)',
    sortNameDesc: 'Nombre (Z-A)',
    sortMarginDesc: 'Mayor margen',
    sortMarginAsc: 'Menor margen',
    sortPriceDesc: 'Precio mayor',
    sortPriceAsc: 'Precio menor',
    detailedSales: 'Ventas Detalladas',
    zeroStock: 'Stock Bajo Mínimo',
    agingReport: 'Antigüedad de Deuda',
    purchaseCost: 'Costo Compra',
    salePrice: 'Precio Venta',
    margin: 'Margen',
    marginPercent: '% Margen',
    price1: 'Precio 1',
    price2: 'Precio 2',
    price3: 'Precio 3',
    allFamilies: 'Todas las familias',
    allProviders: 'Todos los proveedores',
    filterByFamily: 'Filtrar por familia',
    filterByProvider: 'Filtrar por proveedor',
    days: 'días',
    daysOld: 'Días',
    aging0to30: '0-30 días',
    aging31to60: '31-60 días',
    aging61to90: '61-90 días',
    aging91plus: '91+ días',
    allAging: 'Todas las antigüedades',
    searchClientOrAlias: 'Buscar por cliente o alias...',
    searchByAlias: 'Buscar por alias de factura...',
    subtotal: 'Subtotal',
    totalTax: 'IVA Total',
    totalWithTax: 'Total con IVA',
    totalDiscount: 'Descuento Total',
    totalAmount: 'Monto Total',
    cashSales: 'Contado',
    creditSales: 'Crédito',
    itemsCount: 'líneas',
    lastSale: 'Última Venta',
    lastPurchase: 'Última Compra',
    noZeroStockItems: 'No hay artículos por reabastecer',
    billNumber: '# Factura',
    invoiceNumber: '# Factura',
    consecutivoHacienda: 'Consecutivo Hacienda',
    documentKind: 'Tipo',
    lineTax: 'IVA',
    haciendaStatus: 'Estado Hacienda',
    haciendaAccepted: 'Aceptada',
    haciendaRejected: 'Rechazada',
    haciendaPending: 'Pendiente',
    haciendaSubmitted: 'Enviada',
    haciendaFailed: 'Error de envío',
    haciendaNotSent: 'No enviada',
    date: 'Fecha',
    purchaseDate: 'Fecha de compra',
    registrationDate: 'Fecha de registro',
    total: 'Total',
    deposited: 'Abonado',
    qty: 'Cant.',
    unitPriceShort: 'P. Unit',
    unitPriceWithTaxShort: 'P. Unit c/IVA',
    discountShort: 'Desc.',
    balance: 'Saldo',
    aging: 'Antigüedad',
    showing: 'Mostrando',
    ofItems: 'de',
    minimum: 'Mínimo',
    min: 'Min',
    bill: 'Factura',
    totalArticles: 'Artículos',
    totalUnits: 'Unidades',
    costValue: 'Valor a Costo',
    saleValue: 'Valor a Venta',
    potentialProfit: 'Ganancia Potencial',
    // Ventas Detalladas: buscador, filtros y paginación
    lineDetail: 'Detalle de Líneas',
    linesCount: '{count} líneas',
    searchSalesPlaceholder: 'Buscar por factura, cliente o artículo...',
    allPayTypes: 'Contado y crédito',
    onlyCash: 'Solo contado',
    onlyCredit: 'Solo crédito',
    allHaciendaStatuses: 'Todos (Hacienda)',
    noResultsWithFilters: 'Ningún resultado con estos filtros',
    totalsCoverAllFilters: 'Los totales incluyen todas las líneas filtradas, no solo esta página',
  },

  // Export
  export: {
    export: 'Exportar',
    // `csv` quedó sin uso: la opción se quitó del menú (ver export-buttons.tsx).
    // Se conserva la clave por si vuelve.
    csv: 'CSV (para otros sistemas)',
    excel: 'Excel (.xlsx)',
    print: 'Imprimir',
    pdf: 'PDF',
    totals: 'Totales',
  },

  // Deposits (Abonos)
  deposits: {
    title: 'Abonos',
    globalDeposit: 'Abono a Cuenta',
    newDeposit: 'Nuevo Abono',
    amount: 'Monto',
    paymentType: 'Forma de Pago',
    reference: 'Referencia',
    notes: 'Notas',
    notesPlaceholder: 'Notas adicionales (opcional)',
    createDeposit: 'Registrar Abono',
    creating: 'Registrando...',
    remainingBalance: 'Saldo Disponible',
    fullyApplied: 'Aplicado',
    pendingBills: 'Facturas Pendientes',
    pendingBillsCount: 'facturas pendientes',
    noPendingBills: 'No hay facturas pendientes',
    pendingDrafts: 'Facturas pendientes (sin finalizar)',
    showPendingDrafts: 'Mostrar pendientes',
    noPendingDrafts: 'No hay facturas sin finalizar',
    pendingDraftHint: 'Ventas a las que se dio "continuar luego". No suman a la deuda del cliente; son solo un recordatorio.',
    accountSummary: 'Resumen de Cuenta',
    totalDebt: 'Deuda Total',
    availableCredit: 'Crédito Disponible',
    depositHistory: 'Historial de Abonos',
    noDeposits: 'No hay abonos registrados',
    depositSuccess: 'Abono registrado exitosamente',
    remaining: 'Restante',
    appliedTo: 'Aplicado a',
    bills: 'facturas',
    appliedOldestFirst: 'El abono se aplicará a las facturas pendientes en orden cronológico (más antigua primero).',
    amountApplied: 'Monto aplicado',
    notAppliedToBills: 'No aplicado a facturas',
    viewDetails: 'Ver detalle',
    depositRegistered: 'Abono Registrado',
    billsAffected: 'Facturas Alcanzadas',
    remainingDebt: 'Saldo pendiente factura',
    newTotalDebt: 'Nueva Deuda Total',
    paidInFull: 'Pagada',
    backToClient: 'Volver al Cliente',
    makeAnotherDeposit: 'Nuevo Abono',
    referencePlaceholder: 'N° comprobante o referencia',
    noDebtMessage: 'Este cliente no tiene deuda pendiente',
    printReceipt: 'Imprimir Recibo',
    cashier: 'Cajero',
    depositDetail: 'Detalle del Abono',
  },

  // Purchases
  purchases: {
    title: 'Compras',
    newPurchase: 'Nueva Compra',
    receivedDocuments: 'Subir documento',
    providerDataMismatch:
      'Encontramos el proveedor «{name}», pero el nombre, la cédula y/o el tipo de identificación registrados no coinciden con el XML. Al aceptar el documento se actualizarán automáticamente con los datos del XML.',
    providerDataMismatchDetail:
      'Registrado: {currentName} — {currentId} (tipo {currentType}) · XML: {xmlName} — {xmlId} (tipo {xmlType})',
    receiverMismatch:
      'Este documento fue emitido a «{receiverName}» (cédula {receiverId}), pero tu empresa está registrada ante Hacienda con la cédula {tenantId}. Hacienda solo permite responder al receptor del documento, por lo que no se puede aceptar ni rechazar.',
    receiverMismatchAction:
      'Pide al proveedor anular esta factura (nota de crédito) y re-emitirla con la cédula correcta, luego sube el nuevo XML.',
    addFirst: 'Registra tu primera compra',
    provider: 'Proveedor',
    providerInvoice: 'N° Factura Proveedor',
    invoiceNumber: 'Número de factura',
    invoiceDate: 'Fecha de factura',
    notes: 'Notas',
    additionalNotes: 'Notas adicionales',
    createPurchase: 'Crear Compra',
    creating: 'Creando...',
    receive: 'Recibir',
    received: 'Recibida',
    receiveStock: 'Recibir mercadería (actualizar stock)',
    stockUpdated: 'Stock actualizado correctamente',
    receiveError: 'Error al recibir la compra',
    pending: 'Pendiente',
    paid: 'Pagada',
    paidQuestion: '¿Pagada?',
    haciendaColumn: 'Hacienda',
    purchaseDate: 'Fecha de compra',
    registrationDate: 'Fecha de registro',
    subtotalNoTax: 'Subtotal (sin IVA)',
    iva: 'IVA',
    consecutivoHacienda: 'Consecutivo Hacienda',
    claveHacienda: 'Clave Hacienda',
    dateFrom: 'Desde',
    dateTo: 'Hasta',
    cancelled: 'Cancelada',
    cancelPurchase: 'Cancelar Compra',
    purchaseCancelled: 'Compra cancelada',
    pendingPayment: 'Pendientes de pago',
    allStatuses: 'Todos los estados',
    allHaciendaStatuses: 'Todos (Hacienda)',
    haciendaSubmitted: 'Enviado (sin respuesta)',
    awaitingHacienda: 'Enviado a Hacienda. Tocá Sincronizar para ver si lo aceptó o lo rechazó.',
    haciendaAccepted: 'Aceptado',
    haciendaRejected: 'Rechazado por Hacienda',
    haciendaPartial: 'Aceptado parcial',
    haciendaError: 'Error de envío',
    searchProvider: 'Buscar proveedor...',
    searchArticle: 'Buscar artículo...',
    noPurchases: 'No hay compras',
    newPurchaseOrder: 'Nueva Orden de Compra',
    purchaseOrder: 'Compra',
    receivedDoc: {
      title: 'Subir documento de compra',
      subtitle: 'Suba el XML que le envió el proveedor para aceptarlo o rechazarlo ante Hacienda',
      xmlReadError: 'No se pudo leer el XML',
      xmlReadErrorHint: 'Verifique que sea un comprobante electrónico de Hacienda.',
      processFailed: 'No se pudo procesar el documento',
      processFailedHacienda: 'No se pudo procesar el documento ante Hacienda.',
      processFailedTitle: 'No se pudo procesar ante Hacienda',
      processFailedHint: 'El error quedó registrado. Abra Incidencias y pulse "Escanear" para ver el detalle, los datos enviados y recibidos y las posibles causas.',
      viewIncidents: 'Ver en incidencias',
      accepted: 'Documento aceptado',
      partialSent: 'Aceptación parcial enviada',
      rejected: 'Documento rechazado',
      detailMissing: 'Falta el detalle',
      detailMissingHint: 'Indique el motivo o detalle.',
      uploadAnother: 'Subir otro XML',
      selectXml: 'Seleccionar XML del proveedor',
      provider: 'Proveedor',
      providerNotFound: 'No encontramos este proveedor en el sistema. Al aceptar el documento se creará automáticamente con los datos del XML.',
      issuerId: 'Cédula emisor',
      consecutive: 'Consecutivo',
      date: 'Fecha',
      key: 'Clave',
      accept: 'Aceptar',
      partial: 'Parcial',
      reject: 'Rechazar',
      partialTitle: 'Aceptación parcial',
      rejectTitle: 'Rechazar documento',
      partialDetail: 'Detalle de la aceptación parcial',
      rejectReason: 'Motivo del rechazo',
    },
    purchaseInfo: 'Información de Compra',
    purchaseNotFound: 'Compra no encontrada',
    errorLoading: 'Error al cargar la compra',
    doesNotExist: 'La compra no existe',
    backToPurchases: 'Volver a Compras',
    // Line items
    lineItems: 'Líneas',
    noLineItems: 'Sin líneas',
    code: 'Código',
    description: 'Descripción',
    quantity: 'Cantidad',
    unitCost: 'Costo Unitario',
    discount: 'Descuento',
    total: 'Total',
    editLine: 'Editar Línea',
    estimatedTotal: 'Total estimado',
    articleAlreadyAdded: 'Artículo ya agregado',
    articleInPurchase: 'Este artículo ya está en la compra',
    noArticlesFound: 'No se encontraron artículos',
    noProvidersFound: 'No se encontraron proveedores',
    noItems: 'Sin artículos',
    addItemsToStart: 'Busca artículos para agregar',
    stock: 'Stock',
    // Totals
    totals: 'Totales',
    subtotal: 'Subtotal',
    generalDiscount: 'Descuento general',
    tax: 'Impuesto',
    transport: 'Transporte',
    notesPlaceholder: 'Observaciones (opcional)',
    // Payments
    addPayment: 'Agregar Pago',
    payments: 'Pagos',
    amount: 'Monto',
    paymentNotes: 'Notas del pago',
    depositAdded: 'Pago registrado',
    depositError: 'Error al registrar el pago',
    invalidAmount: 'Monto inválido',
    totalPaid: 'Total pagado',
    remainingDebt: 'Saldo pendiente',
    markAsPaid: 'Marcar como pagada',
    markedAsPaid: 'Compra marcada como pagada',
    // Save/Draft
    saved: 'Guardado',
    savedAsDraft: 'Compra guardada como borrador',
    createdAt: 'Creado el',
    // Recepción Hacienda (Mensaje Receptor)
    reception: 'Recepción Hacienda',
    accepted: 'Aceptado',
    partial: 'Parcial',
    partialAcceptance: 'Aceptación parcial',
    rejected: 'Rechazado',
    supplierDocKey: 'Clave del documento del proveedor',
    receiverConsecutive: 'Consecutivo receptor',
    acceptedByHacienda: 'Aceptado por Hacienda',
    haciendaResponse: 'Respuesta de Hacienda',
  },

  // Proformas
  proformas: {
    title: 'Proformas',
    newProforma: 'Nueva Proforma',
    quotation: 'Cotización',
    quotations: 'cotizaciones',
    noProformas: 'Sin proformas',
    addFirst: 'Crea tu primera proforma',
    searchPlaceholder: 'Buscar por cliente o número...',
    proformaNumber: 'N° Proforma',
    convertToInvoice: 'Facturar',
    convert: 'Convertir',
    convertWarning: 'Esta acción convertirá la proforma en una factura definitiva. Esta acción no se puede deshacer.',
    saveProforma: 'Guardar Proforma',
    saved: 'Proforma guardada',
    savedDescription: 'La proforma ha sido guardada exitosamente.',
    creating: 'Creando proforma...',
    stockWarning: 'Advertencia de inventario',
    convertError: 'Error al convertir la proforma',
    notFound: 'Proforma no encontrada',
    errorLoading: 'Error al cargar la proforma',
    doesNotExist: 'Esta proforma no existe',
    backToProformas: 'Volver a proformas',
    proformaInfo: 'Información de la cotización',
    validityNote: 'Nota de validez',
    validityDescription: 'Esta cotización es válida por 30 días a partir de la fecha de emisión. Los precios están sujetos a cambios.',
    deleteProforma: 'Eliminar',
    deleteProformaConfirmTitle: 'Eliminar Proforma',
    deleteProformaConfirmDescription: '¿Está seguro que desea eliminar esta proforma? Esta acción no se puede deshacer.',
    proformaDeleted: 'Proforma eliminada',
    proformaDeletedDescription: 'La proforma ha sido eliminada exitosamente.',
    expirationDate: 'Válida hasta',
    expired: 'Vencida',
    nonFiscalDocument: 'Este documento no es un comprobante fiscal',
    selectExpirationDate: 'Fecha de validez',
  },

  // Geography
  geography: {
    province: 'Provincia',
    canton: 'Cantón',
    district: 'Distrito',
    selectProvince: 'Seleccionar provincia',
    selectCanton: 'Seleccionar cantón',
    selectDistrict: 'Seleccionar distrito',
    address: 'Dirección',
    addressDetails: 'Otras señas',
  },

  // Validation messages
  validation: {
    required: 'Este campo es requerido',
    invalidEmail: 'Correo electrónico inválido',
    minLength: 'Mínimo {min} caracteres',
    maxLength: 'Máximo {max} caracteres',
    mustBePositive: 'Debe ser positivo',
    mustBeInteger: 'Debe ser un número entero',
    invalidFormat: 'Formato inválido',
    passwordTooShort: 'La contraseña debe tener al menos 8 caracteres',
    usernameFormat: 'Solo letras, números y guiones bajos',
    range0100: 'Debe estar entre 0 y 100',
    // Costa Rica specific
    invalidCedula: 'Cédula física debe tener 9 dígitos',
    invalidCedulaJuridica: 'Cédula jurídica debe tener 10 dígitos',
    invalidDimex: 'DIMEX debe tener 11-12 dígitos',
    invalidNite: 'NITE debe tener 10 dígitos',
    invalidExtranjero: 'Identificación de extranjero debe tener entre 1 y 20 caracteres',
    invalidIdentification: 'Identificación inválida para el tipo seleccionado',
    invalidCabys: 'Código CABYS debe tener 13 dígitos',
    positive: 'Debe ser un número positivo',
    amountMustBeGreater: 'El monto debe ser mayor a 0',
    amountCannotExceedDebt: 'El monto no puede exceder la deuda pendiente',
  },

  // Payment Modal
  payment: {
    processPayment: 'Procesar Pago',
    client: 'Cliente',
    completeSale: 'Completar la venta',
    totalToPay: 'Total a Pagar',
    paymentMethod: 'Método de Pago',
    cash: 'Efectivo',
    card: 'Tarjeta',
    transfer: 'Transferencia',
    sinpe: 'SINPE',
    check: 'Cheque',
    other: 'Otro',
    credit: 'Crédito',
    noCredit: 'Cliente sin crédito disponible',
    availableCredit: 'Crédito Disponible',
    termDays: 'Plazo (días)',
    insufficientCredit: 'Crédito insuficiente. Necesita',
    more: 'más',
    amountReceived: 'Monto Recibido',
    quickAdd: 'Agregar Rápido',
    exact: 'Exacto',
    clear: 'Limpiar',
    total: 'Total',
    change: 'Cambio',
    processCard: 'Procesar pago con terminal',
    confirmTransfer: 'Confirme que la transferencia fue recibida',
    cancel: 'Cancelar',
    confirmCreditSale: 'Confirmar Venta a Crédito',
    confirm: 'Confirmar',
    processing: 'Procesando pago...',
    processingDescription: 'Por favor espere mientras se procesa la transacción',
  },

  // Error messages
  errors: {
    somethingWrong: 'Algo salió mal',
    unexpected: 'Ocurrió un error inesperado. Intente recargar la página.',
    reload: 'Recargar página',
    generic: 'Ocurrió un error inesperado',
    network: 'Error de conexión. Verifique su internet.',
    unauthorized: 'No tiene permisos para esta acción',
    notFound: 'No se encontró el recurso',
    serverError: 'Error en el servidor',
    loadingFailed: 'Error al cargar los datos',
    authError: 'Error de autenticación',
    addArticleError: 'Error al agregar artículo',
    updateLineError: 'No se pudo actualizar la línea',
    finalizeError: 'No se pudo finalizar la factura',
    loadReceiptError: 'Error al cargar el recibo',
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    welcome: 'Resumen de tu negocio en tiempo real',
    todaySales: 'Ventas del Mes',
    pendingBills: 'Facturas Pendientes',
    lowStockArticles: 'Artículos con Stock Bajo',
    noLowStock: 'No hay artículos con stock bajo',
    quickActions: 'Acciones Rápidas',
    newSale: 'Nueva Venta',
    newArticle: 'Nuevo Artículo',
    newClient: 'Nuevo Cliente',
    manageArticles: 'Gestionar Artículos',
    salesChart: 'Gráfico de Ventas',
  },

  // Bills list
  bills: {
    countLabel: '{count} facturas',
    notFound: 'Factura no encontrada',
    relatedDocuments: 'Documentos Relacionados',
    originalInvoice: 'Factura Original',
    creditNoteSingular: 'Nota de Crédito',
    creditNotePlural: 'Notas de Crédito',
    title: 'Facturación',
    newBill: 'Nueva Factura',
    viewBill: 'Ver Factura',
    searchPlaceholder: 'Buscar por número, cliente o nota...',
    noBills: 'Sin facturas',
    noResults: 'No se encontraron resultados',
    createFirst: 'Crea tu primera factura',
    billNumber: 'N° Factura',
    type: 'Tipo',
    client: 'Cliente',
    clientNote: 'Nota del cliente',
    clientNotePlaceholder: 'Alias o nota breve (ej: "el del taller", máx. 60)',
    clientNoteEdit: 'Editar nota del cliente',
    clientNoteEmpty: 'Sin nota',
    clientNoteSave: 'Guardar',
    clientNoteCancel: 'Cancelar',
    clientNoteSaved: 'Nota actualizada',
    clientNoteError: 'Error al actualizar la nota',
    date: 'Fecha',
    total: 'Total',
    status: 'Estado',
    actions: 'Acciones',
    print: 'Imprimir',
    continue: 'Continuar',
    continuePending: 'Continuar editando esta factura pendiente',
    generalClient: 'Cliente General',
    allStatuses: 'Todos los estados',
    // Status filters
    filterPending: 'Pendiente',
    filterPaid: 'Pagada',
    filterCredit: 'Crédito',
    filterCancelled: 'Anulada',
    // Date range filter
    dateFrom: 'Desde',
    dateTo: 'Hasta',
    // Detail page
    billNotFound: 'Factura no encontrada',
    errorLoadingBill: 'Error al cargar la factura',
    billDoesNotExist: 'La factura no existe',
    backToBills: 'Volver a facturas',
    billInfo: 'Información de Factura',
    clientInfo: 'Información del Cliente',
    documentType: 'Tipo de Documento',
    paymentType: 'Tipo de Pago',
    paymentMethod: 'Método de Pago',
    createdAt: 'Fecha de Creación',
    seller: 'Vendedor',
    creditTerms: 'Plazo de Crédito',
    transactionNumber: 'N° de Transacción',
    // Line items
    lineItems: 'Artículos',
    noLineItems: 'Sin artículos',
    code: 'Código',
    description: 'Descripción',
    quantity: 'Cantidad',
    unitPrice: 'Precio Unitario',
    discount: 'Descuento',
    // Totals
    totals: 'Totales',
    subtotal: 'Subtotal',
    lineDiscounts: 'Descuentos en Líneas',
    generalDiscount: 'Descuento General',
    tax: 'IVA',
    amountPaid: 'Monto Pagado',
    change: 'Cambio',
    totalDeposited: 'Total Abonado',
    remainingDebt: 'Saldo Pendiente',
    afterDeposit: 'Saldo Después',
    // Deposits
    deposits: 'Abonos',
    addDeposit: 'Agregar Abono',
    addDepositDescription: 'Registrar un pago parcial para esta factura a crédito',
    depositAdded: 'Abono registrado correctamente',
    depositError: 'Error al registrar el abono',
    amount: 'Monto',
    selectPaymentMethod: 'Seleccione método de pago',
    notes: 'Notas',
    notesPlaceholder: 'Notas adicionales (opcional)',
    // Exoneration
    exoneration: 'Exoneración',
    exonerationType: 'Tipo de Exoneración',
    exonerationNumber: 'Número de Documento',
    exonerationPercentage: 'Porcentaje',
    exonerationInstitution: 'Institución',
    // Hacienda
    haciendaStatus: 'Estado en Hacienda',
    allHacienda: 'Todos (Hacienda)',
    notSubmittedToHacienda: 'No enviado a Hacienda',
    haciendaNotSent: 'No enviado',
    sendToHacienda: 'Enviar a Hacienda',
    submittedToHacienda: 'Enviado a Hacienda',
    submitError: 'Error al enviar a Hacienda',
    retry: 'Reintentar',
    pending: 'Pendiente',
    haciendaSuccess: 'Aceptado',
    haciendaFailed: 'Rechazado',
    haciendaPending: 'Pendiente',
    claveHacienda: 'Clave Hacienda',
    consecutivoHacienda: 'Consecutivo',
    submissionHistory: 'Historial de Envíos',
    attempt: 'Intento',
    error: 'Error',
    errorMessage: 'Mensaje de Error',
    requestPayload: 'Datos Enviados',
    responsePayload: 'Respuesta Recibida',
    haciendaResponse: 'Respuesta de Hacienda',
    haciendaAccepted: 'Documento Aceptado por Hacienda',
    haciendaRejected: 'Documento Rechazado por Hacienda',
    // Delete
    deleteBill: 'Eliminar',
    deleteBillConfirmTitle: 'Eliminar Documento',
    deleteBillConfirmDescription: '¿Está seguro que desea eliminar este documento? Se restaurará el inventario. Esta acción no se puede deshacer.',
    billDeleted: 'Documento eliminado',
    billDeletedDescription: 'El documento ha sido eliminado exitosamente.',
    deleteError: 'Error al eliminar el documento',
  },

  // New Bill / POS
  pos: {
    title: 'Nueva Venta',
    proforma: 'Proforma',
    exonerationTypes: {
      t01: 'Compras Autorizadas',
      t02: 'Ventas Exentas a Diplomáticos',
      t03: 'Autorizado por Ley Especial',
      t04: 'Exenciones Dir. Gral. de Hacienda',
      t05: 'Transitorio V',
      t06: 'Transitorio IX',
      t07: 'Transitorio XVII',
      t99: 'Otros',
    },
    finalizeError: 'No se pudo finalizar la venta',
    lineNotFound: 'Línea no encontrada',
    lineUpdated: 'Línea actualizada',
    updateError: 'No se pudo actualizar',
    removeLine: 'Quitar línea',
    priceTier: 'Nivel de precio',
    removeLineTitle: '¿Quitar esta línea de la venta?',
    increaseQuantity: 'Aumentar cantidad',
    decreaseQuantity: 'Disminuir cantidad',
    ticketElectronic: 'Tiquete Electrónico',
    invoiceElectronic: 'Factura Electrónica',
    cash: 'Contado',
    credit: 'Crédito',
    client: 'Cliente',
    clientRequired: '(Requerido)',
    searchClient: 'Buscar cliente',
    searchClientPlaceholder: 'Nombre o cédula...',
    clientName: 'Nombre',
    clientNamePlaceholder: 'Nombre del cliente...',
    clientDetails: 'Datos del receptor',
    idType: 'Tipo ID',
    identification: 'Identificación',
    email: 'Email',
    creditDays: 'Días de crédito',
    noCreditTerm: 'Sin plazo',
    exonerated: 'Cliente exonerado de impuestos',
    exonerationType: 'Tipo de exoneración',
    exonerationNumber: 'Número documento',
    exonerationPercentage: '% Exoneración',
    exonerationInstitution: 'Institución',
    searchArticle: 'Buscar artículo...',
    searching: 'Buscando...',
    noClientsFound: 'No se encontraron clientes',
    noArticlesFound: 'No se encontraron artículos',
    noItems: 'Sin artículos',
    addItemsToStart: 'Busca y agrega artículos para empezar',
    addingItem: 'Agregando...',
    noStock: 'Sin stock',
    stock: 'Stock',
    items: 'artículos',
    item: 'artículo',
    // Payment
    paymentMethod: 'Método de Pago',
    finalizeSale: 'Finalizar Venta',
    save: 'Guardar',
    cancel: 'Cancelar',
    confirmPayment: 'Confirmar Pago',
    totalToPay: 'Total a pagar',
    amountReceived: 'Monto recibido',
    change: 'Cambio',
    transactionNumber: 'Número de transacción',
    optional: 'Opcional',
    confirm: 'Confirmar',
    insufficientAmount: 'Monto insuficiente',
    amountLessThanTotal: 'El monto pagado es menor al total',
    incompleteData: 'Datos incompletos',
    invoiceRequiresClient: 'Para factura electrónica se requiere nombre e identificación del cliente',

    // Alertas de crédito del cliente al abrir una venta
    creditAlertTitle: 'Atención con este cliente',
    creditLimitExceeded: 'Superó el límite de crédito',
    creditLimitDetail: 'Debe {debt} de un límite de {limit}',
    creditLimitOver: 'excedido por {amount}',
    creditNearLimit: 'Le queda {amount} de crédito disponible',
    overdueBillsOne: 'Tiene 1 factura vencida por {amount}',
    overdueBillsMany: 'Tiene {count} facturas vencidas por {amount}',
    overdueOldest: 'la más antigua venció el {date} ({days} días)',
    creditAlertHint: 'Es solo un aviso: podés continuar con la venta.',
    creditRequiresClient: 'Para venta a crédito se requiere nombre e identificación del cliente',
    noItemsError: 'Sin artículos',
    addItemsFirst: 'Agrega artículos antes de finalizar',
    billCompleted: 'Factura completada',
    billSavedOk: 'guardado correctamente',
    saved: 'Guardado',
    savedAsDraft: 'Factura guardada como borrador',
    cancelled: 'Cancelado',
    billCancelled: 'Factura cancelada',
    articleAlreadyAdded: 'Artículo ya agregado',
    articleInBill: 'El artículo ya está en la factura',
    scanNotFound: 'No hay ningún artículo con el código {code}',
    scanCandidates: 'Varios artículos usan el código {code}. Elija cuál:',
    scanError: 'No se pudo buscar el código {code}',
    scanErrorHint: 'Revise la conexión y vuelva a escanear.',
    scanBlocked: 'Termine el cobro antes de escanear más artículos',
    scanButton: 'Escanear',
    moreActions: 'Más opciones',
    saveForLater: 'Continuar luego',
    cancelBill: 'Cancelar factura',
    cancelBillTitle: '¿Cancelar la factura #{id}?',
    cancelBillDescription: 'La factura queda anulada y sus artículos vuelven al inventario.',
    keepBill: 'No, volver',
    keepEditing: 'Seguir editando',
    creditBlockedTitle: 'Cliente sin crédito',
    creditBlockedDescription: '{name} tiene el crédito bloqueado. La factura se cambió a contado.',
    cancelProforma: 'Eliminar proforma',
    cancelProformaTitle: '¿Eliminar la proforma #{id}?',
    cancelProformaDescription: 'La proforma se elimina y no se puede recuperar.',
    scanAdded: '{description} · cantidad {quantity}',
    scanNotAdded: 'No se agregó: {description}',
    cameraScan: 'Escanear con cámara',
    cameraHint: 'Apunte la cámara al código de barras',
    cameraLoading: 'Abriendo la cámara...',
    cameraLastRead: 'Leído: {code}',
    cameraDenied: 'No hay permiso para usar la cámara. Habilítelo en la configuración del navegador para este sitio.',
    cameraUnavailable: 'Este equipo no tiene una cámara disponible.',
    cameraError: 'No se pudo abrir la cámara. Cierre otras aplicaciones que la estén usando y vuelva a intentar.',
    cameraDecoderError: 'No se pudo cargar el lector de códigos. Revise la conexión, cierre y vuelva a intentar.',
    cameraTorchOn: 'Linterna',
    cameraTorchOff: 'Apagar linterna',
    noStockAvailable: 'Sin stock disponible',
    // Edit line
    editLine: 'Editar Línea',
    quantity: 'Cantidad',
    discountPercent: 'Descuento %',
    unitPrice: 'Precio Unitario',
    estimatedTotal: 'Total estimado',
    // Payment methods
    paymentCash: 'Efectivo',
    paymentCard: 'Tarjeta',
    paymentCheck: 'Cheque',
    paymentTransfer: 'Transferencia',
    paymentCollected: 'Recaudado por terceros',
    paymentSinpe: 'SINPE Móvil',
    paymentDigital: 'Plataformas Digitales',
    paymentOther: 'Otros',
    // Cashbox validation
    noCashboxOpen: 'No hay caja abierta',
    mustOpenCashbox: 'Debes abrir una caja antes de poder facturar. Ve a la sección de caja para abrirla.',
    goToCashbox: 'Ir a Caja',
    // CABYS warning
    cabysWarning: 'Sin código CABYS',
    cabysWarningDesc: 'Requerido para facturación electrónica',
    addCabys: 'Agregar CABYS',
    cabysCode: 'Código CABYS',
    cabysPlaceholder: '13 dígitos numéricos',
    cabysUpdated: 'Código CABYS actualizado',
    cabysInvalid: 'El código CABYS debe tener 13 dígitos',
    cabysRequired: 'Código CABYS requerido',
    cabysRequiredDesc: 'Los siguientes artículos no tienen código CABYS. Por favor agrégalos antes de finalizar la venta:',
    addMissingCabys: 'Agregar códigos faltantes',
    // Success screen
    billFinalized: 'Venta Completada',
    viewBill: 'Ver Factura',
    newBill: 'Nueva Factura',
    ticket: 'Tiquete',
    invoice: 'Factura',
    moreItems: 'artículos más',
    orderSummary: 'Resumen del Pedido',
    selectPaymentMethod: 'Seleccione método de pago',
  },

  // Receipts (pages)
  receipts: {
    printed: {
      proformaBanner: 'PROFORMA',
      nonFiscal: 'Documento no fiscal',
      key: 'Clave:',
      type: 'Tipo:',
      billPayment: 'Fac.:',
      number: 'No:',
      date: 'Fecha:',
      validUntil: 'Válida hasta:',
      client: 'Cliente:',
      seller: 'Vende:',
      product: 'Prod',
      price: 'Precio',
      amount: 'Monto',
      subtotal: 'Subtotal:',
      generalDiscount: 'Desc. General:',
      lineDiscount: 'Desc. Linea:',
      tax: 'I.V.A:',
      deposit: 'Abono:',
      total: 'Total:',
      payment: 'Pago:',
      change: 'CAMBIO:',
      thanksPreference: 'GRACIAS POR SU PREFERENCIA',
      thanksPurchase: 'GRACIAS POR SU COMPRA',
      version: 'Versión de comprobantes 4.4',
      depositReceipt: 'RECIBO DE ABONO',
      accountDepositReceipt: 'RECIBO DE ABONO A CUENTA',
      billHash: 'Factura #:',
      paymentType: 'Tipo Pago:',
      billTotal: 'Total Factura:',
      billDate: 'Fecha Factura:',
      depositAmount: 'Monto Abono:',
      totalDeposited: 'Total Abonado:',
      pendingBalance: 'Saldo Pendiente:',
      depositDate: 'Fecha Abono:',
      cashier: 'Cajero:',
      thanksDeposit: 'GRACIAS POR SU ABONO',
      reference: 'Referencia:',
      appliedBills: 'FACTURAS APLICADAS',
      notes: 'Notas:',
      originalBill: 'Factura Orig.:',
      attendedBy: 'Atendio:',
      returnedArticle: 'Artículo Devuelto:',
      quantity: 'Cantidad:',
      unitPrice: 'Precio Unit.:',
      discount: 'Descuento:',
      totalUpper: 'TOTAL:',
      reason: 'Motivo:',
      returnedProduct: 'PRODUCTO DEVUELTO',
      proformaDisclaimer: 'Este documento es una cotización y no tiene validez fiscal. Los precios están sujetos a cambios sin previo aviso.',
      legalNotice: 'Documento emitido conforme lo establecido en la resolución de Factura Electrónica número DGT-R-033-2019 del veintisiete de junio de dos mil diecinueve de la Dirección General de Tributación',
      idPrefix: 'Ced. #',
      phonePrefix: 'Tel:',
      consecutive: 'Consecutivo:',
    },
    errorLoading: 'Error al cargar el recibo',
    notFound: 'Recibo no encontrado',
    print: 'Imprimir',
  },

  // Receipt (thermal print format)
  receipt: {
    title: 'Recibo',
    notFound: 'Recibo no encontrado',
    back: 'Volver',
    print: 'Imprimir',
    type: 'Tipo',
    invoice: 'Fac.',
    number: 'No',
    date: 'Fecha',
    client: 'Cliente',
    seller: 'Vende',
    product: 'Prod',
    qty: '#',
    price: 'Precio',
    amount: 'Monto',
    subtotal: 'Subtotal',
    generalDiscount: 'Desc. General',
    lineDiscount: 'Desc. Línea',
    iva: 'I.V.A',
    deposit: 'Abono',
    total: 'Total',
    payment: 'Pago',
    changeAmount: 'CAMBIO',
    thanksMessage: 'GRACIAS POR SU COMPRA',
    haciendaNotice: 'Documento emitido conforme lo establecido en la resolución de Factura Electrónica número DGT-R-033-2019 del veintisiete de junio de dos mil diecinueve de la Dirección General de Tributación',
    version: 'Versión de comprobantes 4.4',
  },

  // Exoneration types (Alanube/Hacienda v4.4)
  exoneration: {
    type01: 'Compras Autorizadas',
    type02: 'Ventas Exentas a Diplomáticos',
    type03: 'Autorizado por Ley Especial',
    type04: 'Exenciones Dir. Gral. de Hacienda',
    type05: 'Transitorio V',
    type06: 'Transitorio IX',
    type07: 'Transitorio XVII',
    type99: 'Otros',
  },

  // Identification types
  idTypes: {
    type01: 'Cédula Física',
    type02: 'Cédula Jurídica',
    type03: 'DIMEX',
    type04: 'NITE',
    type05: 'Extranjero',
  },

  // Electronic Invoicing
  history: {
    viewHistory: 'Ver historial de envíos',
    title: 'Historial de Envíos',
    documentsCount: '{count} documentos',
    searchPlaceholder: 'Buscar cliente o consecutivo…',
    filterByStatus: 'Filtrar por estado',
    allStatuses: 'Todos los estados',
    statusPending: 'Pendiente',
    statusSubmitted: 'Enviado',
    statusAccepted: 'Aceptado',
    statusRejected: 'Rechazado',
    statusFailed: 'Error',
    docTicket: 'Tiquete',
    docInvoice: 'Factura',
    docCreditNote: 'Nota de Crédito',
    docDebitNote: 'Nota de Débito',
    empty: 'No hay documentos que mostrar',
  },

  incidents: {
    titleShort: 'Incidencias de facturación',
    short: 'Incidentes',
    title: 'Incidencias de Facturación',
    activeInView: '{active} activas · {total} en vista',
    inView: '{total} en vista',
    noPermission: 'No tiene permisos para ver esta página',
    scan: 'Escanear',
    scanDone: 'Escaneo completo',
    scanError: 'Error al escanear',
    searchPlaceholder: 'Buscar cliente, consecutivo o mensaje de error…',
    filterActive: 'Activas',
    filterAll: 'Todas',
    filterOpen: 'Abiertas',
    filterInProgress: 'En proceso',
    filterResolved: 'Resueltas',
    filterDismissed: 'Descartadas',
    type: 'Tipo',
    allTypes: 'Todos los tipos',
    typeSubmissionError: 'Error de envío',
    typeRejected: 'Rechazado',
    typeConnectionError: 'Error de conexión',
    errorCategory: 'Categoría de error',
    allErrorCategories: 'Todas las categorías de error',
    order: 'Orden',
    newestFirst: 'Más recientes primero',
    oldestFirst: 'Más antiguas primero',
    empty: 'No hay incidencias que mostrar',
    emptyHint: 'Use "Escanear" para detectar documentos con error o rechazo.',
    range: '{from}-{to} de {total}',
    generalClient: 'Cliente General',
    work: 'Trabajar',
    statusOpen: 'Abierta',
    statusInProgress: 'En proceso',
    statusResolved: 'Resuelta',
    statusDismissed: 'Descartada',
    detail: {
      title: 'Incidencia #{id}',
      copied: '{label} copiado',
      noteMissing: 'Falta la nota',
      noteMissingHint: 'Indique cómo se resolvió o por qué se descarta la incidencia.',
      updated: 'Incidencia actualizada',
      updateError: 'Error al actualizar',
      resent: 'Reenviado',
      resentWithError: 'Reenvío con error',
      resendError: 'Error al reenviar',
      syncFailed: 'No se pudo sincronizar',
      synced: 'Estado sincronizado',
      syncError: 'Error al sincronizar',
      client: 'Cliente',
      amount: 'Monto',
      consecutive: 'Consecutivo',
      haciendaStatus: 'Estado actual en Hacienda',
      incidentStatus: 'Estado de la incidencia',
      acceptedByHacienda: 'Aceptado por Hacienda',
      statusInHacienda: 'Estado en Hacienda',
      resend: 'Reenviar a Hacienda',
      sync: 'Sincronizar estado',
      attempts: 'Intentos de envío ({count})',
      attempt: 'Intento #{n}',
      jsonSent: 'JSON enviado',
      jsonReceived: 'JSON recibido',
      noPayload: 'No hay datos registrados para este intento.',
      resolutionNote: 'Nota de resolución',
      resolutionNoteHint: 'Describa cómo se solucionó el problema (o el motivo si se descarta).',
      resolutionNotePlaceholder: 'Ej.: Se corrigió la cédula del cliente y se reenvió; Hacienda lo aceptó.',
      closedBy: 'Cerrada por {name} · {date}',
      markInProgress: 'Marcar en proceso',
      backToOpen: 'Volver a abierta',
      markResolved: 'Marcar resuelta',
      dismiss: 'Descartar',
      reopen: 'Reabrir',
    },
    notSent: 'Sin enviar',
    moreErrors: '(+{count} más)',
    whatToDo: 'Qué hacer:',
    viewRawMessage: 'Ver mensaje original',
    viewFullMessage: 'Ver mensaje completo de Hacienda',
    categories: {
      cabys_invalid: {
        label: 'CABYS inválido',
        description: 'El código CABYS del artículo no es válido para la actividad económica.',
        action: 'Abra el artículo de esa línea y corrija el CABYS por uno de la lista oficial; el siguiente reenvío actualiza la factura.',
      },
      receiver_id_format: {
        label: 'Cédula del cliente mal formada',
        description: 'La cédula del receptor no cumple el formato exigido (p. ej. cédula física = 9 dígitos sin guiones).',
        action: 'Revise el cliente y corrija el número de identificación (sin guiones ni ceros a la izquierda).',
      },
      receiver_id_not_found: {
        label: 'Receptor no existe en Hacienda',
        description: 'Hacienda no encontró la cédula del receptor en el padrón. Suele pasar con clientes nuevos o cédulas mal digitadas.',
        action: 'Confirme la cédula en la consulta de contribuyentes de Hacienda (TRIBU-CR). Si el cliente no está inscrito, emita un tiquete o use otra identificación.',
      },
      receiver_activity_invalid: {
        label: 'Actividad económica del receptor inválida',
        description: 'El código de actividad económica del receptor no existe o está inactivo en el catálogo de Hacienda.',
        action: 'En el detalle de la factura corrija la actividad del receptor (o déjela vacía para que no se envíe) y vuelva a enviar.',
      },
      sender_activity_invalid: {
        label: 'Actividad económica del emisor inválida',
        description: 'La actividad económica configurada para su empresa no es aceptada por Hacienda para este documento.',
        action: 'Revise los datos de la empresa en Configuración y actualice el código de actividad.',
      },
      tax_inconsistent: {
        label: 'IVA inconsistente',
        description: 'La tasa o el cálculo del IVA reportado no coincide con lo que Hacienda esperaba.',
        action: 'Revise la tasa de IVA aplicada al artículo y, si es exonerado o exento, que la configuración del cliente sea coherente.',
      },
      duplicate_consecutive: {
        label: 'Consecutivo duplicado',
        description: 'Hacienda ya recibió un documento con este consecutivo.',
        action: 'Sincronice el estado: probablemente el documento ya fue aceptado y solo falta actualizar el estado local.',
      },
      certificate: {
        label: 'Firma / llave criptográfica',
        description: 'Problema con la firma electrónica o la llave criptográfica del emisor.',
        action: 'Revise en Configuración → Facturación Electrónica que la llave criptográfica esté vigente y, si no, renuévela.',
      },
      auth: {
        label: 'Error de autenticación',
        description: 'Las credenciales de facturación electrónica no fueron aceptadas (401/403).',
        action: 'Revise las credenciales de la empresa en Configuración → Facturación Electrónica y reintente.',
      },
      connection: {
        label: 'Sin respuesta de Hacienda',
        description: 'El documento se envió pero el veredicto final de Hacienda aún no se conoce.',
        action: 'Use "Sincronizar estado": si Hacienda ya lo aceptó, la incidencia se resuelve sola.',
      },
      other: {
        label: 'Otro error',
        description: 'No se pudo clasificar el mensaje. Revise el texto original.',
        action: 'Lea el mensaje de Hacienda al detalle para entender qué hay que corregir.',
      },
    },
  },

  invoicing: {
    rejectedFound: 'Hacienda rechazó {count} comprobante(s)',
    checkingHacienda: 'Consultando estados en Hacienda…',
    rejectedFoundHint: 'Filtre por estado Rechazado para revisarlos.',
    statusTooltip: 'Facturación: {status}',
    title: 'Facturación Electrónica',
    subtitle: 'Integración con Hacienda Costa Rica',
    // Status
    enabled: 'Habilitada',
    disabled: 'Deshabilitada',
    connected: 'Conectado',
    disconnected: 'Desconectado',
    notConfigured: 'No configurado',
    warning: 'Advertencia',
    // Configuration
    environment: 'Ambiente',
    production: 'Producción',
    sandbox: 'Pruebas (Sandbox)',
    credentials: 'Credenciales',
    credentialsConfigured: 'Configuradas',
    credentialsNotConfigured: 'No configuradas',
    lastSync: 'Última sincronización',
    never: 'Nunca',
    failedCount: 'Documentos fallidos',
    lastError: 'Último error',
    // Actions
    enable: 'Habilitar',
    disable: 'Deshabilitar',
    viewDocuments: 'Ver Documentos Enviados',
    viewPending: 'Ver Pendientes',
    retryFailed: 'Reintentar Fallidos',
    resetCounter: 'Reiniciar Contador',
    // Documents
    pendingDocuments: 'Documentos Pendientes',
    noPendingDocuments: 'No hay documentos pendientes',
    submissionHistory: 'Historial de Envíos',
    noSubmissionHistory: 'No hay intentos de envío registrados',
    attempt: 'Intento',
    // Statistics
    statistics: 'Estadísticas',
    totalSubmitted: 'Total Enviados',
    totalAccepted: 'Aceptados',
    totalRejected: 'Rechazados',
    totalPending: 'Pendientes',
    totalErrors: 'Con Errores',
    successRate: 'Tasa de Éxito',
    // Messages
    enableSuccess: 'Facturación electrónica habilitada',
    disableSuccess: 'Facturación electrónica deshabilitada',
    cannotEnableNoCredentials: 'No se puede habilitar sin credenciales configuradas',
    configInitialized: 'Configuración inicializada correctamente',
    counterReset: 'Contador reiniciado correctamente',
    // Admin only
    adminOnly: 'Solo administradores',
    configureInEnv: 'Configure las credenciales en las variables de entorno del servidor',
    // v4.4 - PDF/XML Download
    downloadPdf: 'Descargar PDF',
    downloadXml: 'Descargar XML',
    pdfDownloaded: 'PDF descargado correctamente',
    xmlDownloaded: 'XML descargado correctamente',
    downloadError: 'Error al descargar el documento',
    // v4.4 - Sync Status
    syncStatus: 'Sincronizar',
    syncing: 'Sincronizando...',
    statusUpdated: 'Estado actualizado correctamente',
    statusUnchanged: 'El estado no ha cambiado',
    syncError: 'Error al sincronizar el estado',
    // v4.4 - Cancel Document
    cancelDocument: 'Anular',
    cancelDocumentTitle: 'Anular Documento',
    cancelDocumentDescription: 'Esta acción creará una nota de crédito que anulará completamente este documento. Esta acción no se puede deshacer.',
    confirmCancel: 'Confirmar Anulación',
    cancelSuccess: 'Documento anulado correctamente. Se ha creado una nota de crédito.',
    cancelError: 'Error al anular el documento',
    // v4.4 - REP (Recibo Electrónico de Pago)
    repTitle: 'Recibo Electrónico de Pago',
    sendRep: 'Enviar REP',
    repSent: 'REP enviado correctamente',
    repError: 'Error al enviar REP',
    // v4.4 - Export Invoice
    exportInvoice: 'Factura de Exportación',
    submitExport: 'Enviar como Exportación',
    destinationCountry: 'País de destino',
    exportSent: 'Factura de exportación enviada correctamente',
    exportError: 'Error al enviar la factura de exportación',
    // v4.4 - Credit Notes
    createCreditNote: 'Crear Nota de Crédito',
    creditNoteTitle: 'Nota de Crédito',
    creditNoteDescription: 'Crea una nota de crédito para revertir parcial o totalmente esta factura',
    creditNoteSuccess: 'Nota de crédito creada exitosamente',
    creditNoteError: 'Error al crear la nota de crédito',
    // v4.4 - Debit Notes
    createDebitNote: 'Crear Nota de Débito',
    debitNoteTitle: 'Nota de Débito',
    debitNoteDescription: 'Crea una nota de débito para agregar cargos adicionales a esta factura',
    debitNoteSuccess: 'Nota de débito creada exitosamente',
    debitNoteError: 'Error al crear la nota de débito',
    // Reference Codes
    selectReferenceCode: 'Seleccione el motivo',
    referenceCodeDesc: 'Elija el motivo de la nota de crédito',
    referenceReason: 'Razón o detalle',
    referenceReasonPlaceholder: 'Describa el motivo de la nota (opcional)',
    // Item Selection
    selectItems: 'Seleccionar artículos',
    selectItemsDesc: 'Seleccione los artículos y cantidades a devolver',
    selectAll: 'Seleccionar todos',
    deselectAll: 'Deseleccionar todos',
    adjustQuantity: 'Ajustar cantidad',
    adjustPrice: 'Ajustar precio',
    // Preview
    preview: 'Confirmar',
    previewDesc: 'Revise los detalles antes de crear la nota de crédito',
    notePreview: 'Vista previa',
    noteTotal: 'Total de la nota',
    originalDocument: 'Documento original',
    // Wizard Steps
    step1Reason: 'Paso 1: Motivo',
    step2Items: 'Paso 2: Artículos',
    step3Preview: 'Paso 3: Confirmar',
    stepReason: 'Motivo',
    stepItems: 'Artículos',
    stepConfirm: 'Confirmar',
    detail: 'Detalle',
    chargeDescriptionLabel: 'Descripción',
    quantity: 'Cantidad',
    price: 'Precio',
    cabysPlaceholder: '13 dígitos',
    // Charges (Debit Note)
    addCharge: 'Agregar cargo',
    additionalCharges: 'Cargos adicionales',
    additionalChargesHint: 'Agregue los cargos a aplicar',
    chargeDescription: 'Descripción del cargo',
    chargeAmount: 'Monto',
    noCharges: 'Sin cargos agregados',
    addChargesFirst: 'Agregue al menos un cargo para continuar',
    // Reference Codes Labels
    referenceCode01: 'Anula documento de referencia',
    referenceCode02: 'Corrige texto del documento',
    referenceCode03: 'Corrige monto del documento',
    referenceCode04: 'Referencia a otro documento',
    referenceCode05: 'Sustituye comprobante provisional',
    referenceCode06: 'Devolución de mercancía',
    referenceCode07: 'Sustituye comprobante electrónico',
    referenceCode08: 'Factura endosada',
    referenceCode09: 'Nota de crédito financiera',
    referenceCode10: 'Nota de débito financiera',
    referenceCode11: 'Proveedor no domiciliado',
    referenceCode12: 'Crédito exoneración posterior',
    // Warnings
    creditNoteWarning: 'Esta acción creará una nota de crédito que afectará el documento original. Esta operación no se puede deshacer.',
    debitNoteWarning: 'Esta acción creará una nota de débito que agregará cargos al cliente. Esta operación no se puede deshacer.',
    confirmCreate: 'Confirmar y Crear',
    creating: 'Creando...',
  },

  // Footer and Product Info
  footer: {
    productName: 'InvoSloth',
    version: 'v2.0',
    haciendaVersion: 'Hacienda v4.4',
    createdBy: 'Desarrollado por',
    creator: 'WeCode Software Sloth',
    website: 'https://wecode.nasarca.dev/',
    copyright: 'Todos los derechos reservados',
    electronicInvoicing: 'Facturación Electrónica',
    costaRica: 'Costa Rica',
    // Footer sections
    business: 'Negocio',
    developedBy: 'Desarrollado por',
    enterpriseSolutions: 'Soluciones de software empresarial',
    fast: 'Rápido',
    secure: 'Seguro',
    identification: 'Cédula',
    // Hacienda info
    haciendaIntegrationDesc: 'Integración con el Ministerio de Hacienda',
    haciendaFeatures: 'Comprobantes electrónicos, CABYS, REP y más',
    haciendaFullDesc: 'Facturación electrónica integrada con el Ministerio de Hacienda. Comprobantes electrónicos, CABYS, REP y códigos CIIU actualizados.',
  },

  // Welcome Dashboard
  welcome: {
    greeting: 'Bienvenido',
    businessName: 'Negocio',
    subtitle: 'Sistema de Facturación Electrónica',
    todaySummary: 'Resumen de hoy',
    haciendaIntegration: 'Integración con Hacienda',
    haciendaVersion: 'Versión de comprobantes',
    connectedToHacienda: 'Conectado a Hacienda Costa Rica',
  },

  // Economic Activities
  activities: {
    economicActivities: 'Actividades Económicas',
    economicActivity: 'Actividad Económica',
    activityCode: 'Código',
    activityName: 'Nombre de Actividad',
    addActivity: 'Agregar Actividad',
    removeActivity: 'Eliminar',
    selectActivity: 'Seleccionar actividad económica',
    taxRateInfo: 'Tarifa IVA',
    noActivities: 'No hay actividades configuradas',
    atLeastOneActivity: 'Debe haber al menos una actividad',
    receiverActivity: 'Actividad del Receptor',
    receiverActivityPlaceholder: 'Código de actividad del cliente',
    receiverActivitySaved: 'Actividad del receptor actualizada',
    receiverActivityError: 'No se pudo actualizar la actividad del receptor',
    receiverActivityEditHint: 'Se puede corregir mientras Hacienda no tenga el comprobante. Al reenviar sale con esta actividad.',
    clientInfoSaved: 'Datos del cliente actualizados',
    lookingUp: 'Consultando actividades en Hacienda...',
    taxpayerNotFound: 'Contribuyente no encontrado en Hacienda',
    lookupError: 'No se pudo consultar Hacienda',
    retry: 'Reintentar',
    enterManually: 'Ingresar manualmente',
    noActivitiesFound: 'No se encontraron actividades activas',
    lookupFromHacienda: 'Consultar en Hacienda',
    catalogUnavailable: 'El catálogo de actividades no está disponible en este momento. Intenta de nuevo más tarde.',
    notInAlanubeCatalog: 'No disponible en facturación electrónica',
    notInAlanubeCatalogShort: 'No en FE',
    notInAlanubeCatalogWarning: 'Este código no está en el catálogo de facturación electrónica. Se omitirá al emitir facturas.',
    searchPlaceholder: 'Buscar por código o nombre...',
    useClientActivity: 'Usar actividad del cliente',
    allActivities: 'Catálogo completo',
    catalogLoading: 'Cargando catálogo de actividades...',
    noResults: 'Sin resultados',
    clearSelection: 'Limpiar',
  },

  // Etiquetas de código de barras (Artículos → Etiquetas)
  labels: {
    open: 'Etiquetas',
    printArticle: 'Imprimir etiquetas',
    saveAndPrint: 'Guardar e imprimir',
    title: 'Etiquetas de código de barras',
    subtitle: 'Elija los artículos. La cantidad arranca en sus existencias: una etiqueta por unidad.',
    searchPlaceholder: 'Buscar o escanear un artículo...',
    noResults: 'Ningún artículo coincide',
    notFound: 'No hay ningún artículo con el código {code}',
    added: '{code} agregado',
    addedAgain: '{code} ya estaba: se sumó una etiqueta',
    empty: 'Todavía no hay artículos. Búsquelos arriba o escanee su código.',
    articles: 'Artículos',
    quantity: 'Cantidad',
    stock: '{count} en existencia',
    useStock: 'Usar existencias',
    allToStock: 'Todas según existencias',
    remove: 'Quitar',
    removeAll: 'Quitar todos',
    format: 'Formato',
    formatRoll50x26: 'Rollo 5 × 2,6 cm',
    formatRoll35x26: 'Rollo 3,5 × 2,6 cm',
    formatRoll50x50: 'Rollo 5 × 5 cm',
    formatRollHint: 'Impresora térmica de etiquetas. Formato principal',
    formatRollSmallHint: 'Impresora térmica. Para piezas pequeñas',
    formatRollSquareHint: 'Impresora térmica. Letra más grande y precio destacado',
    formatAvery: 'Hoja de etiquetas adhesivas',
    formatAveryHint: 'Hoja carta Avery 5160 u 8160 en impresora común: 30 etiquetas de 2⅝" × 1"',
    formatCounter: 'Hoja de mostrador',
    formatCounterHint: 'Carta, 8 códigos grandes para tener junto a la caja',
    showPrice: 'Mostrar el precio',
    startAt: 'Empezar en la etiqueta',
    startAtHint: 'Para aprovechar una hoja ya empezada. Se cuentan de izquierda a derecha y de arriba abajo.',
    summary: '{labels} etiquetas · {pages} hojas',
    summaryOnePage: '{labels} etiquetas · 1 hoja',
    summaryRoll: '{labels} etiquetas',
    summaryRollOne: '1 etiqueta',
    summaryOne: '1 etiqueta · 1 hoja',
    print: 'Imprimir',
    downloadPdf: 'Descargar PDF',
    printTip: 'Elija la impresora y deje "Copias" en 1: la cantidad ya va en cada artículo. El tamaño carta, los márgenes y la escala ya vienen puestos. Si imprime el PDF descargado, use tamaño real (100 %).',
    printTipRoll: 'Elija la impresora de etiquetas y deje "Copias" en 1: la cantidad ya va en cada artículo. El tamaño de la etiqueta, los márgenes y la escala ya vienen puestos.',
    preview: 'Vista previa',
    morePages: 'Y {count} hojas más en el PDF.',
    moreLabels: 'Y {count} etiquetas más en el PDF.',
    tooLong: 'Estos códigos son muy largos para esta etiqueta y las barras pueden salir demasiado finas para el lector. Use una etiqueta más grande o la hoja de mostrador: {codes}',
    unprintable: 'Estos códigos llevan tildes o ñ y no se pueden imprimir como código de barras: {codes}',
    sheetTitle: '{business} · códigos de barras',
    counterHint: 'Escanee el código del artículo con el lector o la cámara.',
    fileName: 'etiquetas',
    loadFailed: 'No se pudieron cargar {count} de los artículos',
    printedTitle: 'Se registraron {count} etiquetas como impresas',
    printedHint: 'El asistente de inventario ya las descuenta de lo que falta. Si no salieron bien, márquelo para quitar el registro.',
    printedDone: 'Listo',
    confirmNo: 'No se imprimieron',
    undone: 'Se quitó el registro de {count} etiquetas',
    recorded: 'Se registraron {count} etiquetas impresas',
    inventoryOpen: 'Asistente de inventario',
    inventoryTitle: 'Asistente para imprimir el inventario',
    inventorySubtitle: 'Imprima las etiquetas de todo el inventario por lotes, ordenado por familia. Al confirmar cada lote, lo completo sale de la lista.',
    inventoryArticlesProgress: '{done} de {articles} artículos con todas sus etiquetas',
    inventoryDone: 'Completos',
    inventoryPartialNote: 'Nota: {count} artículos están parcialmente impresos (tienen algunas etiquetas, pero no todas).',
    inventoryPartialNoteOne: 'Nota: 1 artículo está parcialmente impreso (tiene algunas etiquetas, pero no todas).',
    inventoryFamily: 'Familia',
    inventoryAllFamilies: 'Todas las familias',
    inventoryNoFamily: 'Sin familia',
    inventoryFamilyOption: '{name} · faltan {count}',
    inventoryStatusPending: 'Pendientes',
    inventoryStatusDone: 'Completos',
    inventoryStatusAll: 'Todos',
    inventoryBatchSize: 'Artículos por lote',
    inventoryStock: 'Existencias',
    inventoryPrinted: 'Impresas',
    inventoryMissing: 'Faltan',
    inventoryLastPrinted: 'Última impresión',
    inventoryNever: 'Nunca',
    inventoryBatch: 'Este lote: {articles} artículos · {labels} etiquetas',
    inventoryPrintBatch: 'Imprimir este lote',
    inventoryBatchCapped: 'Al imprimir, cada artículo lleva como mucho 999 etiquetas; lo que falte queda para el lote siguiente.',
    inventoryMarkPrinted: 'Marcar como impresos',
    inventoryMarkTitle: '¿Marcar el lote como impreso?',
    inventoryMarkDescription: 'Se registran como impresas todas las etiquetas que faltan ({labels} de {articles} artículos), sin imprimirlas. Úselo para lo que ya tiene su etiqueta. Acá no aplica el tope de 999 por artículo, porque no se imprime nada.',
    inventoryAllComplete: 'Todo el inventario tiene sus etiquetas.',
    inventoryEmpty: 'No hay artículos en esta vista.',
  },

  // Settings page
  settings: {
    title: 'Configuración',
    invoicingEnabledToast: 'Facturación electrónica activada',
    invoicingDisabledToast: 'Facturación electrónica desactivada',
    toggleFailed: 'No se pudo cambiar el estado',
    params: {
      exchangeRate: 'Tipo de Cambio',
      exchangeRateDesc: 'USD a CRC',
      taxRate: 'IVA',
      taxRateDesc: 'Porcentaje de impuesto',
      marginRetail: 'Margen Detalle',
      marginWholesale: 'Margen Mayorista',
      marginDistributor: 'Margen Distribuidor',
      level1: 'Nivel 1 (%)',
      level2: 'Nivel 2 (%)',
      level3: 'Nivel 3 (%)',
      profitMargins: 'Márgenes de Ganancia',
      updated: 'Parámetro actualizado correctamente',
      updateFailed: 'No se pudo actualizar el parámetro',
      invalidNumber: 'El valor debe ser un número válido',
      editTitle: 'Editar {name}',
      parameter: 'Parámetro',
      value: 'Valor',
    },
    company: {
      description: 'Información de la empresa para facturas y recibos',
      legalName: 'Razón Social',
      legalNamePlaceholder: 'Nombre legal de la empresa',
      tradeName: 'Nombre Comercial',
      tradeNamePlaceholder: 'Nombre comercial (si es diferente)',
      idType: 'Tipo de Identificación',
      selectType: 'Seleccionar tipo',
      idNumber: 'Número de Identificación',
      idShort: 'Cédula',
      emailPlaceholder: 'correo@empresa.com',
      phone: 'Teléfono',
      locationTitle: 'Ubicación (requerido para facturación electrónica)',
      province: 'Provincia',
      canton: 'Cantón',
      district: 'Distrito',
      address: 'Otras Señas',
      addressPlaceholder: '100 metros norte del parque central…',
      activityName: 'Nombre de actividad',
      invalidActivityCode: 'Código "{code}" inválido. Use el formato de Hacienda: 4 dígitos, punto y 1 dígito (ej.: 4530.0).',
      activityNameRequired: 'Cada actividad debe tener un nombre.',
      updated: 'Información de la empresa actualizada correctamente',
      updateFailed: 'No se pudo actualizar la información',
      locationMissing: 'Falta configurar la ubicación (provincia, cantón, distrito) para facturación electrónica',
      branchTerminal: 'Sucursal / Terminal',
      empty: 'No hay información de la empresa configurada',
      configure: 'Configurar Empresa',
    },
    subtitle: 'Ajustes del sistema y preferencias',
    // Profile
    myProfile: 'Mi Perfil',
    accountInfo: 'Información de tu cuenta',
    username: 'Usuario',
    email: 'Email',
    notConfigured: 'No configurado',
    changePassword: 'Cambiar Contraseña',
    // System params
    systemParams: 'Parámetros del Sistema',
    generalConfig: 'Configuración general del sistema',
    exchangeRate: 'Tipo de Cambio',
    usdToCrc: 'USD a CRC',
    tax: 'Impuesto (IVA)',
    companyData: 'Datos de la Empresa',
    fiscalInfo: 'Información fiscal',
    edit: 'Editar',
    // Backup
    dataAndBackup: 'Datos y Respaldos',
    dataManagement: 'Gestión de datos del sistema',
    exportData: 'Exportar Datos',
    generateBackup: 'Generar Respaldo',
    lastBackup: 'Último respaldo',
    today: 'Hoy',
    atTime: 'a las',
    // Password change
    changePasswordDescription: 'Ingresa tu contraseña actual y la nueva contraseña',
    currentPassword: 'Contraseña Actual',
    newPassword: 'Nueva Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    passwordTooShort: 'La contraseña debe tener al menos 6 caracteres',
    passwordChanged: 'Contraseña actualizada correctamente',
    passwordChangeError: 'Error al cambiar la contraseña',
    // Coming soon
    comingSoon: 'Próximamente',
    featureInDevelopment: 'Esta función está en desarrollo',
    // Integración con Hacienda. El proveedor que hace de intermediario no se
    // nombra en pantalla: para el usuario el trámite es ante Hacienda.
    haciendaIntegration: 'Integración Hacienda',
    haciendaIntegrationSubtitle: 'Facturación electrónica para Hacienda Costa Rica',
    companyId: 'ID Empresa',
    companyRegistration: 'Empresa Registrada',
    companyRegistered: 'Registrada',
    companyNotRegistered: 'No Registrada',
    registerCompany: 'Registrar Empresa',
    registerCompanyHint:
      'Necesitará la llave criptográfica (.p12) y las credenciales de comprobantes electrónicos que se generan en TRIBU-CR',
    setUpCredentialsToStart: 'Configure las credenciales para comenzar',
    configureIntegrationForConsecutivos: 'Configure la integración con Hacienda para ver los consecutivos',
    certificateNotStoredLocally:
      'La llave se guarda cifrada y solo se usa para firmar sus comprobantes ante Hacienda.',
    reviewBeforeRegistering: 'Revise la información antes de registrar su empresa.',
    companyRegisteredOk: 'La empresa ha sido registrada correctamente',
    companyRegisterError: 'No se pudo registrar la empresa',
    registration: {
      stepCompany: 'Empresa',
      stepKey: 'Llave',
      stepCredentials: 'Credenciales',
      stepConfirm: 'Confirmar',
      stepOf: 'Paso {current} de {total}',
      dataComplete: 'Datos completos',
      dataIncomplete: 'Datos incompletos',
      dataCompleteHint: 'Su empresa tiene toda la información requerida',
      missingFields: 'Faltan: {fields}',
      companyData: 'Datos de la Empresa',
      legalName: 'Razón Social',
      identification: 'Cédula',
      identificationType: 'Tipo',
      email: 'Correo Electrónico',
      notConfigured: 'No configurado',
      haciendaConfig: 'Configuración Hacienda',
      branch: 'Sucursal',
      terminal: 'Terminal',
      branchHint: '3 dígitos, normalmente 001',
      terminalHint: '5 dígitos, normalmente 00001',
      keyIntro:
        'Suba la llave criptográfica (.p12) que generó en TRIBU-CR, la Oficina Virtual de Hacienda.',
      invalidFile: 'Archivo inválido',
      invalidFileHint: 'Seleccione un archivo .p12 o .pfx',
      noFileSelected: 'No se ha seleccionado la llave criptográfica',
      changeFile: 'Cambiar archivo',
      dropHere: 'Arrastre la llave aquí o',
      selectFile: 'Seleccionar archivo',
      formats: 'Formatos: .p12, .pfx',
      keyPin: 'PIN de la llave criptográfica',
      keyPinPlaceholder: 'El PIN de 4 dígitos que definió al generarla',
      credentialsIntro:
        'Ingrese el usuario y la contraseña de comprobantes electrónicos que entrega TRIBU-CR. No son los de su ingreso a la Oficina Virtual.',
      username: 'Usuario de comprobantes',
      usernameExampleProduction: 'Ej.: cpf-01-0234-0567@prod.comprobanteselectronicos.go.cr',
      usernameExampleSandbox: 'Ej.: cpf-01-0234-0567@stag.comprobanteselectronicos.go.cr',
      password: 'Contraseña de comprobantes',
      passwordPlaceholder: 'Contraseña de comprobantes',
      credentialsPurpose: 'Con estas credenciales se envían los comprobantes a Hacienda.',
      summaryTitle: 'Resumen del registro',
      summaryCompany: 'Empresa:',
      summaryIdentification: 'Cédula:',
      summaryKey: 'Llave criptográfica:',
      summaryUsername: 'Usuario de comprobantes:',
      summaryEnvironment: 'Ambiente:',
      sandboxTitle: 'Ambiente de pruebas',
      sandboxHint:
        'Los documentos enviados no tendrán validez fiscal. Cambie a Producción cuando esté listo.',
      successTitle: 'Registro exitoso',
      errorTitle: 'Error en el registro',
      registering: 'Registrando...',
      back: 'Atrás',
    },
    renewKey: {
      intro:
        'Suba la nueva llave criptográfica (.p12) que generó en TRIBU-CR para continuar facturando electrónicamente.',
      importantTitle: 'Importante',
      importantHint:
        'La llave debe estar vigente y corresponder a la cédula de esta empresa. La llave anterior será reemplazada.',
      title: 'Renovar llave criptográfica',
      subtitle: 'Actualizar la llave de firma de los comprobantes',
      noFileSelected: 'No se ha seleccionado la llave criptográfica',
      renewed: 'Llave renovada',
      renewedDescription: 'La llave criptográfica se actualizó correctamente',
      renewFailed: 'No se pudo renovar la llave criptográfica',
      invalidFile: 'Archivo inválido',
      invalidFileDescription: 'Seleccione un archivo .p12 o .pfx',
      selectFileFirst: 'Seleccione el archivo de la llave criptográfica',
      enterPin: 'Ingrese el PIN de la llave criptográfica',
      notAvailable: 'No disponible',
      statusExpired: 'Llave vencida',
      statusExpiringSoon: 'Llave por vencer',
      statusValid: 'Llave vigente',
      expiresOn: 'Vence: {date}',
      expiredDaysAgo: 'Vencida hace {days} días',
      daysLeft: '{days} días restantes',
      changeFile: 'Cambiar archivo',
      dropHere: 'Arrastre la llave aquí o',
      selectFile: 'Seleccionar archivo',
      acceptedFormats: 'Formatos aceptados: .p12, .pfx',
      uploading: 'Subiendo…',
      upload: 'Subir llave',
      showPin: 'Mostrar PIN',
      hidePin: 'Ocultar PIN',
    },
    tribuGuide: {
      titleKey: '¿Dónde consigo la llave criptográfica?',
      titleCredentials: '¿Dónde consigo el usuario y la contraseña?',
      sandboxBadge: 'Pruebas',
      productionBadge: 'Producción',
      openPortal: 'Abrir TRIBU-CR',
      stepLogin:
        'Entre a la Oficina Virtual de TRIBU-CR. Si administra varios contribuyentes, escoja el de esta empresa.',
      stepMenu: 'En el menú vaya a Información → Tico Factura.',
      stepOtherProgram:
        'La primera vez le pregunta si va a facturar con Tico Factura: marque "No, voy a utilizar otro programa".',
      keyStepSandbox:
        'En Mi perfil → Credenciales pruebas descargue la llave de pruebas (.p12) y anote su PIN.',
      keyStepProduction:
        'En Mi perfil → Llave criptográfica toque "Generar una nueva llave criptográfica", defina un PIN de 4 dígitos y descargue el archivo.',
      credentialsStepSandbox:
        'En Mi perfil → Credenciales pruebas copie el usuario (termina en @stag.comprobanteselectronicos.go.cr) y su contraseña.',
      credentialsStepProduction:
        'En Mi perfil → Contraseña toque "Descargar usuario y contraseña". El usuario termina en @prod.comprobanteselectronicos.go.cr.',
      sandboxNote:
        'Esta empresa está en ambiente de pruebas: use solo las "Credenciales pruebas", nunca la llave de producción.',
      revokeWarning:
        'Generar una llave nueva revoca la anterior: si ya factura con otro sistema, ese sistema deja de poder firmar.',
      notOviPassword:
        'El usuario y la contraseña de comprobantes no son los mismos con que entra a la Oficina Virtual.',
      menusMayVary: 'Los nombres de los menús pueden variar un poco según la versión de TRIBU-CR.',
    },
    // Estado de la integración
    statusNotRegistered: 'No registrado',
    statusCertificateExpired: 'Llave criptográfica vencida',
    statusCertificateExpiringSoon: 'Llave criptográfica por vencer',
    statusCertificatePending: 'Llave criptográfica pendiente',
    statusConnected: 'Conectado',
    renewCertificateToKeepBilling: 'Renueve la llave criptográfica para continuar facturando',
    certificateExpiresInDays: 'Su llave criptográfica vence en {days} días',
    certificateNotAuthorizedYet: 'La llave criptográfica aún no ha sido autorizada por Hacienda',
    readyToIssueDocuments: 'Sistema listo para emitir documentos electrónicos',
    // Detalle
    environment: 'Ambiente',
    environmentSandbox: 'Pruebas (Sandbox)',
    environmentProduction: 'Producción',
    digitalCertificate: 'Llave criptográfica',
    certificateAuthorized: 'Autorizado',
    certificatePending: 'Pendiente',
    certificateExpired: 'Expirado',
    certificateNotConfigured: 'Sin configurar',
    validUntil: 'Válido hasta',
    certificateExpiringSoonTitle: 'Llave criptográfica próxima a vencer',
    cannotIssueUntilRenewed: 'No podrá emitir documentos electrónicos hasta renovar la llave criptográfica.',
    renewBeforeExpiry: 'Le recomendamos renovar la llave criptográfica antes del vencimiento.',
    renewCertificate: 'Renovar llave criptográfica',
    // Interruptor de facturación
    invoicingActive: 'Facturación Activa',
    invoicingInactive: 'Facturación Inactiva',
    invoicingSentAutomatically: 'Las facturas se envían automáticamente a Hacienda',
    invoicingNotSent: 'Las facturas no se envían a Hacienda',
  },
}

export type TranslationKeys = typeof es
